/**
 * NF Bundle UX (UX-Test-Theme, 2026-09-25)
 *
 * Erweitert die Theme-Kopie des Bundle Selectors (nf-bundle-selector.js) um:
 *  - Auswahl-Sheet: erst Front-Art, dann Größe als Liste + Anzahl. Arbeitet auf
 *    einem Entwurf: übernommen wird genau die angezeigte Menge, Schließen verwirft.
 *  - Schritt-2-Liste: gewählte Fronten untereinander mit Stepper, "Ändern" und Zeilensumme.
 *  - Farbwechsel-Dialog: fragt, ob gewählte Fronten die neue Farbe übernehmen.
 *  - Warenkorb: zusätzliche versteckte Eigenschaften für die Gruppierung im Drawer
 *    und "Bearbeiten" (ersetzt die alte Zusammenstellung beim erneuten Hinzufügen).
 *
 * Lädt nach nf-bundle-selector.js und startet danach initBundleSelectors().
 */
(function () {
  'use strict';
  var BS = window.BundleSelector;
  if (!BS) return;
  var P = BS.prototype;

  var SIZE_NAMES = ['größe', 'groesse', 'size', 'länge', 'laenge', 'maße', 'masse', 'maß'];
  var COLOR_NAMES = ['farbe', 'color', 'colour', 'couleur'];
  var NOUNS = {
    'türen': ['Tür', 'Türen'],
    'schubladen': ['Schublade', 'Schubladen'],
    'griffe': ['Griff', 'Griffe'],
    'verkleidungselemente': ['Element', 'Elemente']
  };
  var MEASURE_URL = '/pages/ausmessen-fronten';
  var CUSTOM_SIZE_URL = '/pages/gratis-angebot';
  // Griffposition (assets/nf-griff.js, lädt vorher): Modern = Kante, Iconic = Mulde; null = keine Auswahl
  var G = window.NFGriff || null;
  function gSpec(product) { return G && product ? G.spec(product) : null; }
  // Code im Schlüssel „sectionId_variantId_code“ (Standard: ohne Code, wie bisher)
  function keyCode(key) { var p = String(key || '').split('_'); return p.length > 2 ? p.slice(2).join('_') : ''; }

  // Menge als ganze Zahl (landet roh im HTML; Teilen-Link/Speicher prüft nf-bundle-selector.js, das hier ist die zweite Sperre)
  function qn(q) { var n = parseInt(q, 10); return n > 0 ? Math.min(99, n) : 0; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    var parts = n.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + '€';
  }
  function optName(o) { return String(o && o.name != null ? o.name : o || '').toLowerCase().trim(); }
  function optIndex(product, names) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) if (names.indexOf(optName(opts[i])) !== -1) return i;
    return -1;
  }
  function vOpt(v, i) { return v['option' + (i + 1)]; }
  // „Hintergrund Farbe der Griffe“ (Iconic inkl. Griff): Index der Option oder -1
  function bgIndex(product) {
    var opts = (product && product.options) || [];
    for (var i = 0; i < opts.length; i++) if (/hintergrund/i.test(optName(opts[i]))) return i;
    return -1;
  }
  var BG_DEFAULT = 'Gleiche Farbe wie die Fronten';
  function same(a, b) { return String(a || '').toLowerCase().trim() === String(b || '').toLowerCase().trim(); }
  function parseSize(s) {
    var m = String(s || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    return m ? [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))] : null;
  }
  function prettySize(s) { return String(s || '').replace(/\s*[x×]\s*/i, ' × '); }
  function nounFor(sectionTitle, n) {
    var pair = NOUNS[String(sectionTitle || '').toLowerCase().trim()];
    if (!pair) return n === 1 ? 'Stück' : 'Stück';
    return n === 1 ? pair[0] : pair[1];
  }

  // Hausregel: kein Leerzeichen vor dem Euro-Zeichen (gilt für alle Bundle-Anzeigen).
  P.formatMoney = function (priceInput) {
    var cents;
    if (typeof priceInput === 'string') {
      cents = priceInput.indexOf('.') !== -1 ? Math.round(parseFloat(priceInput) * 100) : (parseInt(priceInput, 10) || 0);
    } else {
      cents = priceInput || 0;
    }
    return money(cents);
  };

  /* ------------------------------------------------------------------ */
  /* Farbe aus Schritt 1                                                 */
  /* ------------------------------------------------------------------ */

  function normColor(s) {
    return String(s || '').toLowerCase().replace(/y/g, 'i').replace(/[^a-zäöüß]/g, '');
  }
  // Farbe aus einem Radio in Schritt 1. Der Titel ist der Variantentitel; mehrere Optionen trennt
  // Shopify mit " / " (mit Leerzeichen). Ein „/“ OHNE Leerzeichen gehört zum Farbnamen (Blau/Grau).
  function radioColor(input) {
    if (!input) return '';
    var t = input.getAttribute('title') || '';
    return t.split(' / ')[0].trim();
  }
  // wie Shopifys handleize (snippets/color-swatches.liquid: .swatch-custom-color-{{ name | handleize }})
  function handleize(s) {
    return String(s || '').toLowerCase().replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // Das Theme nennt die Farb-Radios name="variant-id"; die App-Erkennung
  // findet sie nicht. Deshalb zuerst direkt aus Schritt 1 lesen.
  P.nfReadStepOneColor = function () {
    var picker = document.querySelector('[data-nf-variant-picker]');
    if (!picker) return null;
    var r = picker.querySelector('input[name="variant-id"]:checked') || picker.querySelector('input[type="radio"]:checked');
    if (r) {
      var t = radioColor(r);
      if (!t) { var lab = picker.querySelector('label[for="' + r.id + '"]'); t = lab ? lab.textContent.trim() : ''; }
      if (t) return t;
    }
    var name = picker.querySelector('.nf-swatch-label');
    return name ? name.textContent.trim() : null;
  };

  // Hintergrund der Griffe aus Schritt 1 (Radio/Select, dessen Name „Hintergrund“ enthält).
  // detectAndSetMainProductBackground liefert null, solange das zuletzt geöffnete Fenster eine eigene
  // Sammlung hat (Griffe) – deshalb hier direkt lesen, mit selectedBackgroundFilter als Rückfall.
  P.nfReadStepOneBg = function () {
    var root = document.querySelector('[data-nf-variant-picker]') || document;
    var els = root.querySelectorAll('input[type="radio"]:checked, select');
    for (var i = 0; i < els.length; i++) {
      if (/hintergrund/i.test(els[i].name || '') && els[i].value) return els[i].value;
    }
    return this.selectedBackgroundFilter || null;
  };

  // Farbfeld wie in Schritt 1 (Farbe oder Holzbild per CSS-Klasse swatch-custom-color-*)
  var _swCache = {};
  P.nfSwatchStyle = function (color) {
    if (!color) return 'background:#e2e0da';
    var k = normColor(color);
    if (_swCache[k]) return _swCache[k];
    var picker = document.querySelector('[data-nf-variant-picker]');
    var style = null;
    if (picker) {
      var inputs = picker.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length && !style; i++) {
        if (normColor(radioColor(inputs[i])) !== k) continue;
        var lab = picker.querySelector('label[for="' + inputs[i].id + '"]');
        var ic = lab && (lab.querySelector('i') || lab.querySelector('img'));
        if (!ic) continue;
        if (ic.tagName === 'IMG') { style = 'background:#e2e0da url(' + JSON.stringify(ic.currentSrc || ic.src) + ') center/cover'; break; }
        var cs = getComputedStyle(ic);
        var img = cs.backgroundImage && cs.backgroundImage !== 'none' ? cs.backgroundImage : '';
        var bg = cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)' ? cs.backgroundColor : '';
        if (img || bg) style = 'background-color:' + (bg || '#e2e0da') + (img ? ';background-image:' + img + ';background-size:cover;background-position:center' : '');
      }
    }
    if (!style) style = swatchClassStyle(color);
    if (!style) { var hex = this.getColorHex && this.getColorHex(color); style = 'background:' + (hex || '#e2e0da'); }
    _swCache[k] = style;
    return style;
  };
  // Farbe steht nicht im Picker (z. B. Picker gerade ersetzt): globale Swatch-Klasse aus
  // snippets/color-swatches.liquid an einem unsichtbaren Probe-Element auslesen
  function swatchClassStyle(color) {
    var h = handleize(color);
    if (!h || !document.body) return null;
    var probe = document.createElement('i');
    probe.className = 'swatch-custom-color-' + h;
    probe.style.cssText = 'position:absolute;left:-9999px;top:0;width:10px;height:10px;';
    document.body.appendChild(probe);
    var cs = getComputedStyle(probe);
    var img = cs.backgroundImage && cs.backgroundImage !== 'none' ? cs.backgroundImage : '';
    var bg = cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)' ? cs.backgroundColor : '';
    probe.remove();
    if (!img && !bg) return null;
    return 'background-color:' + (bg || '#e2e0da') + (img ? ';background-image:' + img + ';background-size:cover;background-position:center' : '');
  }

  var FINISH_NAMES = ['oberfläche', 'oberflaeche', 'finish', 'ausführung', 'ausfuehrung'];
  var FINISHES = [
    ['bronze antik', 'linear-gradient(135deg,#b8905e,#a57c4b 50%,#6f5231)'],
    ['kupfer antik', 'linear-gradient(135deg,#b07a52,#9d6743 55%,#6b4329)'],
    ['stahl antik', 'linear-gradient(135deg,#a3a3a3,#8a8a8a 55%,#5f5f5f)'],
    ['edelstahl', 'linear-gradient(135deg,#eceeef,#b9bcbf 55%,#8f9396)'],
    ['stahl', 'linear-gradient(135deg,#eceeef,#c0c0c0 55%,#8f9396)'],
    ['chrom', 'linear-gradient(135deg,#f4f5f6,#c3c6c9 50%,#9ea2a6)'],
    ['bronze', 'linear-gradient(135deg,#ecc99a,#dbb17e 50%,#a7824f)'],
    ['kupfer', 'linear-gradient(135deg,#d9955a,#b87333 55%,#8a5424)'],
    ['messing', 'linear-gradient(135deg,#f0d98a,#c9a54a 55%,#9b7a2c)'],
    ['gold', 'linear-gradient(135deg,#f0d98a,#c9a54a 55%,#9b7a2c)'],
    ['zinklegierung', '#a6a8a6'],
    ['anthrazit', '#6b6f6a'],
    ['schwarz', '#191a1b'],
    ['weiß', '#ffffff'],
    ['weiss', '#ffffff']
  ];
  P.nfFinishStyle = function (name) {
    if (!name) return null;
    var n = String(name).toLowerCase().trim();
    for (var i = 0; i < FINISHES.length; i++) {
      if (n === FINISHES[i][0] || n.indexOf(FINISHES[i][0]) !== -1) return 'background:' + FINISHES[i][1];
    }
    var hex = this.getColorHex && this.getColorHex(name);
    return hex ? 'background:' + hex : null;
  };
  // Farbe bzw. Oberfläche einer Variante (Fronten: "Farbe", Griffe: "Oberfläche")
  P.nfVariantFinish = function (product, variant) {
    var ci = optIndex(product, COLOR_NAMES);
    if (ci !== -1) return { name: vOpt(variant, ci), front: true };
    var fi = optIndex(product, FINISH_NAMES);
    if (fi !== -1) return { name: vOpt(variant, fi), front: false };
    return null;
  };

  var _origDetect = P.detectAndSetMainProductColor;
  P.detectAndSetMainProductColor = function () {
    var raw = this.nfReadStepOneColor();
    if (raw) {
      var list = (this.availableColors || []).map(function (c) { return typeof c === 'string' ? c : (c && (c.name || c.value)) || ''; });
      var hit = list.find(function (c) { return same(c, raw); }) ||
                list.find(function (c) { return normColor(c) === normColor(raw); }) ||
                list.find(function (c) { var a = normColor(c), b = normColor(raw); return a && b && (a.indexOf(b) !== -1 || b.indexOf(a) !== -1); });
      if (hit || !list.length) { this.selectedColorFilter = hit || raw; return this.selectedColorFilter; }
    }
    return _origDetect.apply(this, arguments);
  };

  /* ------------------------------------------------------------------ */
  /* Hilfen                                                              */
  /* ------------------------------------------------------------------ */

  P.nfSection = function (sectionId) {
    return (this.sections || []).find(function (s) { return s.sectionId === sectionId; }) || null;
  };

  // Farbe ist fest vorgegeben, wenn der Bereich die Haupt-Collection nutzt
  // (Fronten). Eigene Collections (z. B. Griffe) wählen ihre Optionen frei.
  P.nfLockedColor = function (sectionConfig) {
    if (!sectionConfig || this.sectionUsesOwnCollection(sectionConfig)) return null;
    return this.selectedColorFilter || null;
  };

  // Stil · Oberfläche (ohne Farbe) aus Schritt 1
  P.nfStyleLine = function () {
    var s = (this.sections || []).find(function (x) { return !x.collectionHandle; }) || {};
    return [s.filterStyle, s.filterSurface].filter(function (x) { return x && String(x).trim(); }).join(' · ');
  };

  // Kopfzeile im Auswahl-Popup: Farbe aus Schritt 1 (gilt für NEU gewählte Fronten)
  P.nfConfigLine = function () {
    return [this.nfStyleLine(), this.selectedColorFilter].filter(function (x) { return x && String(x).trim(); }).join(' · ');
  };

  // Farbe der Zusammenstellung aus den tatsächlich gewählten Fronten (nicht aus Schritt 1):
  // eine Farbe → diese, mehrere → „mehrere Farben“, keine Farb-Option → leer
  P.nfFrontsColor = function () {
    var self = this, seen = [];
    this.selectedProducts.forEach(function (it) {
      if (self.sectionUsesOwnCollection(self.nfSection(it.sectionId) || {})) return;
      var c = self.nfItemColor(it);
      if (c && !seen.some(function (x) { return same(x, c); })) seen.push(c);
    });
    return seen.length > 1 ? 'mehrere Farben' : (seen[0] || '');
  };
  P.nfCartConfigLine = function () {
    return [this.nfStyleLine(), this.nfFrontsColor()].filter(function (x) { return x && String(x).trim(); }).join(' · ');
  };

  // Bild der Warenkorb-Karte in der Farbe der Zusammenstellung (wie die Kopfzeile im Drawer). Vorher immer
  // das Hauptbild des Produkts in einer festen Farbe (Felix 19.10.2026: Beige gewählt, Karte zeigte Kurkuma).
  //  - eine Farbe: Variantenbild dieser Farbe; hat sie keins → '' (der Drawer zeigt dann das Farbfeld)
  //  - mehrere/keine Farbe: Bild der Farbe aus Schritt 1, sonst das Hauptbild
  P.nfGroupImage = function () {
    var map = this.settings.mainImages, main = this.settings.mainImage || '';
    if (!map) return main;
    function pick(c) {
      if (!c) return '';
      var k;
      for (k in map) if (Object.prototype.hasOwnProperty.call(map, k) && same(k, c)) return map[k];
      for (k in map) if (Object.prototype.hasOwnProperty.call(map, k) && normColor(k) === normColor(c)) return map[k];
      return '';
    }
    var c = this.nfFrontsColor();
    if (c && c !== 'mehrere Farben') return pick(c);
    return pick(this.selectedColorFilter || this.nfReadStepOneColor()) || main;
  };

  P.nfGroupTitle = function () {
    var h = String(this.settings.productHandle || '').toLowerCase();
    if (h.indexOf('metod') !== -1) return 'METOD Küche';
    if (h.indexOf('pax') !== -1 || h.indexOf('schrank') !== -1) return 'PAX Schrank';
    return 'Fronten';
  };

  P.nfItemColor = function (item) {
    var ci = optIndex(item.product, COLOR_NAMES);
    return ci === -1 ? null : vOpt(item.selectedVariant, ci);
  };

  P.nfItemLabel = function (item) {
    var title = this.getProductDisplayTitle(item.product);
    var si = optIndex(item.product, SIZE_NAMES);
    var size = si === -1 ? '' : vOpt(item.selectedVariant, si);
    return size ? title + ' ' + prettySize(size) : title;
  };

  /* ------------------------------------------------------------------ */
  /* Griffposition (Felix 2026-10-12, Bauplan griff/plan.md)             */
  /*  - Position = Feld griff je Eintrag; Schlüssel beim Standard wie     */
  /*    bisher (sectionId_variantId), sonst sectionId_variantId_code –    */
  /*    alte Links/Speicherstände bedeuten so „Standard“                  */
  /*  - gleiche Größe in zwei Positionen = zwei Einträge/Warenkorbzeilen  */
  /* ------------------------------------------------------------------ */

  // Position eines Eintrags: Feld griff, sonst Code im Schlüssel, sonst Standard der Front ('' = keine Auswahl)
  P.nfGriffOf = function (it, key) {
    var s = it && gSpec(it.product);
    return s ? G.norm(it.griff || keyCode(key), s) : '';
  };
  P.nfKey = function (sectionId, variant, product, code) {
    return sectionId + '_' + variant.id + (G ? G.suffix(gSpec(product), code, '_') : '');
  };
  // Schlüssel und Feld griff aller Einträge vereinheitlichen (nach Laden aus Speicher/Link, vor dem Warenkorb).
  // Gleiche Variante + Position (z. B. ungültiger Code → Standard) wird zusammengelegt; Reihenfolge bleibt.
  P.nfGriffRekey = function () {
    var self = this, changed = false, merged = new Map();
    this.selectedProducts.forEach(function (it, key) {
      var code = self.nfGriffOf(it, key);
      var nk = it.product && it.selectedVariant ? self.nfKey(it.sectionId, it.selectedVariant, it.product, code) : key;
      if (code) { if (it.griff !== code) { it.griff = code; changed = true; } } else if (it.griff) { delete it.griff; changed = true; }
      if (nk !== key) changed = true;
      var ex = merged.get(nk);
      if (ex) { ex.quantity = Math.min(99, (ex.quantity || 1) + (it.quantity || 1)); changed = true; }
      else merged.set(nk, it);
    });
    if (changed) this.selectedProducts = merged;
    return changed;
  };
  // ganze Zeile auf eine andere Position verschieben (gibt es die Zielzeile schon: Mengen addieren) → neuer Schlüssel
  P.nfMoveGriff = function (key, code) {
    var it = this.selectedProducts.get(key);
    var s = it && gSpec(it.product);
    if (!s) return key;
    code = G.norm(code, s);
    var nk = this.nfKey(it.sectionId, it.selectedVariant, it.product, code);
    if (nk === key) { it.griff = code; return key; }
    var target = this.selectedProducts.get(nk), merged = new Map();
    // zusammen mehr als 99: nicht verschieben (sonst fielen Fronten still weg, Befund F7) → null, der Aufrufer sagt es
    if (target && qn(target.quantity) + (qn(it.quantity) || 1) > 99) return null;
    this.selectedProducts.forEach(function (v, k) {
      if (k === key) { if (!target) merged.set(nk, { product: it.product, selectedVariant: it.selectedVariant, quantity: it.quantity || 1, sectionId: it.sectionId, griff: code }); return; }
      if (k === nk) { v.quantity = Math.min(99, (v.quantity || 1) + (it.quantity || 1)); }
      merged.set(k, v);
    });
    this.selectedProducts = merged;
    return nk;
  };
  // Sheet: alle Fronten dieser Art (Entwurf, aktueller Bereich) auf die aktive Position stellen; gleiche Größe wird
  // zusammengelegt. Über 99 je Größe: nichts ändern → { blocked: Hinweistext }; sonst { n: verschobene Menge }
  P.nfDraftMoveAll = function (pid) {
    var st = this._nf, self = this;
    if (!st) return { n: 0 };
    var prod = null;
    st.draft.forEach(function (it) { if (!prod && String(it.product.id) === String(pid) && it.sectionId === st.sectionId) prod = it.product; });
    var gs = prod && gSpec(prod);
    if (!gs) return { n: 0 };
    var act = G.norm(st.gpos[pid], gs), sum = {}, n = 0, over = null;
    st.draft.forEach(function (it) {
      if (String(it.product.id) !== String(pid) || it.sectionId !== st.sectionId) return;
      var vid = String(it.selectedVariant.id);
      sum[vid] = (sum[vid] || 0) + qn(it.quantity);
      if (G.norm(it.griff, gs) !== act) n += qn(it.quantity);
      if (sum[vid] > 99 && !over) over = it;
    });
    if (!n) return { n: 0 };
    if (over) {
      var si = optIndex(prod, SIZE_NAMES);
      return { blocked: 'Nicht umgestellt: ' + (si === -1 ? 'eine Größe' : prettySize(vOpt(over.selectedVariant, si))) + ' hätte zusammen mehr als 99. Bitte zuerst die Anzahl verringern.' };
    }
    var merged = new Map();
    st.draft.forEach(function (it, k) {
      if (String(it.product.id) !== String(pid) || it.sectionId !== st.sectionId) { merged.set(k, it); return; }
      var nk = self.nfKey(it.sectionId, it.selectedVariant, it.product, act);
      var ex = merged.get(nk);
      if (ex) { ex.quantity = qn(ex.quantity) + qn(it.quantity); return; }
      var d = { product: it.product, selectedVariant: it.selectedVariant, quantity: qn(it.quantity), sectionId: it.sectionId };
      if (act) d.griff = act;
      merged.set(nk, d);
    });
    st.draft = merged;
    return { n: n };
  };
  // Zeilen-Beschriftung für Screenreader (zwei Zeilen gleicher Größe unterscheiden sich nur in der Position)
  P.nfRowLabel = function (it, key) {
    var g = this.nfGriffOf(it, key);
    return this.nfItemLabel(it) + (g ? ', ' + G.label(g) : '');
  };

  P.nfTotals = function (sectionIds) {
    var count = 0, total = 0, compare = 0;
    this.selectedProducts.forEach(function (it) {
      if (sectionIds && sectionIds.indexOf(it.sectionId) === -1) return;
      var q = qn(it.quantity) || 1, p = parseInt(it.selectedVariant.price, 10) || 0;
      var c = parseInt(it.selectedVariant.compare_at_price, 10) || 0;
      count += q; total += p * q; compare += (c > p ? c : p) * q;
    });
    return { count: count, total: total, compare: compare };
  };

  P.nfAfterChange = function (sectionIds) {
    var self = this;
    this.nfGriffRekey();
    (sectionIds || (this.sections || []).map(function (s) { return s.sectionId; })).forEach(function (id) {
      self.renderSelectedProductsForSection(id);
    });
    this.updateSectionHeaderSummaries();
    this.updateBundleAddToCartButton();
    try { this.saveToLocalStorage(); } catch (e) {}
  };

  // Jede Zusammenfassung (auch nach Laden aus Speicher/Link) meldet den Stand an Akkordeon und mobile Leiste.
  var _origHeaders = P.updateSectionHeaderSummaries;
  P.updateSectionHeaderSummaries = function () {
    _origHeaders.call(this);
    var t = this.nfTotals();
    var self = this;
    var own = (this.sections || []).filter(function (c) { return self.sectionUsesOwnCollection(c); }).map(function (c) { return c.sectionId; });
    var main = (this.sections || []).map(function (c) { return c.sectionId; }).filter(function (id) { return own.indexOf(id) === -1; });
    var tf = this.nfTotals(main), tg = this.nfTotals(own);
    var detail = { count: t.count, total: t.total, compare: t.compare, totalText: money(t.total), compareText: money(t.compare),
      fronts: { count: tf.count, totalText: money(tf.total) }, griffe: { count: tg.count, totalText: money(tg.total) } };
    window.__nfBundleState = detail; // für Zuhörer, die später starten (Akkordeon)
    window.dispatchEvent(new CustomEvent('nf:bundle-changed', { detail: detail }));
  };

  /* ------------------------------------------------------------------ */
  /* Modal öffnen/schließen                                             */
  /* ------------------------------------------------------------------ */

  P.nfShowModal = function () {
    this.modal.classList.add('is-open', 'nf-sheet-mode');
    document.documentElement.classList.add('nf-overlay-open');
    this.savedScrollY = window.scrollY || 0;
    document.body.classList.add('bundle-modal-open');
    document.documentElement.classList.add('bundle-modal-open');
    this.lowerFixedElementsZIndex();
    var st = this.modal.style;
    st.setProperty('display', 'flex', 'important');
    st.setProperty('z-index', '2147483647', 'important');
    st.setProperty('position', 'fixed', 'important');
    st.setProperty('top', '0', 'important');
    st.setProperty('left', '0', 'important');
    st.setProperty('right', '0', 'important');
    st.setProperty('bottom', '0', 'important');
    st.visibility = 'visible';
    st.opacity = '1';
    document.body.style.overflow = 'hidden';
  };

  P.nfSheetRoot = function () {
    var content = this.modal.querySelector('.bundle-modal-content');
    var root = content.querySelector('.nf-sheet');
    if (!root) {
      root = document.createElement('div');
      root.className = 'nf-sheet';
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.setAttribute('aria-labelledby', 'nf-sheet-title');
      content.appendChild(root);
      var self = this;
      root.addEventListener('click', function (e) { self.nfSheetClick(e); });
      root.addEventListener('change', function (e) { self.nfSheetChange(e); });
      // Griffposition: Pfeiltasten im Raster (assets/nf-griff.js)
      root.addEventListener('keydown', function (e) { if (G) G.onKey(e); });
    }
    return root;
  };

  /* ------------------------------------------------------------------ */
  /* Auswahl-Sheet v2: Mehrfachauswahl (Entwurf je Kategorie)            */
  /*  - Mobil: Liste der Front-Arten -> Größen mit Stepper je Größe      */
  /*  - Desktop (ab 900px): Liste links, Größen rechts, ein Fenster       */
  /*  - Übernommen wird erst mit "Alle übernehmen"; Schließen mit         */
  /*    offenen Änderungen fragt nach                                    */
  /* ------------------------------------------------------------------ */

  var WIDE = '(min-width: 900px)';

  // Tab/Shift+Tab bleiben im offenen Dialog
  function trapFocus(e, container) {
    if (!container) return;
    var f = Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; }
    );
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (!container.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // „+ 5,5 cm“ nicht umbrechen (sonst „… + 5,5“ / „cm (links)“ im schmalen Sheet)
  function keepUnits(s) {
    return String(s).replace(/\+ (?=\d)/g, '+\u00a0').replace(/(\d) (cm|mm)\b/g, '$1\u00a0$2');
  }

  // Strich-Icons je Front-Art (wie Entwurf 6.3); Griffe behalten ihr Foto
  function frontIcon(title, tall) {
    var t = String(title || '').toLowerCase();
    var right = /rechts/.test(t) && !/links\s*\/\s*rechts/.test(t);
    var a = 'width="40" height="40" viewBox="0 0 40 40" fill="#DDDBD1" stroke="#272924" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true"';
    var dot = function (x, y) { return '<circle cx="' + x + '" cy="' + y + '" r="1.2" fill="#272924" stroke="none"/>'; };
    // Umgebung (Schrank) als heller Drahtrahmen wie beim Unterschrankpaneel; gefüllt ist nur das Teil selbst
    var ctx = function (d) { return '<path d="' + d + '" fill="none" stroke="#77756D" stroke-width="1.1" stroke-linecap="round"/>'; };
    // Spiegeln für die andere Seite (links ↔ rechts). transform-origin 0 0 inline: screen.css setzt
    // „* { transform-origin: center }“, damit würde die Matrix das Bild um 40 px aus dem Feld schieben
    var flip = function (s, m) { return m ? '<g transform="matrix(-1 0 0 1 40 0)" style="transform-origin:0 0">' + s + '</g>' : s; };
    // PAX-Korpus von schräg vorne rechts (Front 15 × 29, Tiefe 7 nach rechts oben), Front offen
    var pax = 'M8 9H23V38H8ZM8 9L15 2H30M15 2V31H23';
    if (/sockel/.test(t)) return '<svg ' + a + '><rect x="2" y="25" width="36" height="7"/></svg>';
    // PAX-Abdeckleiste (10/15 × 201/236 cm) = schmale Blende vorne an der Korpuskante, steht seitlich über
    // (schließt die Lücke zur Wand) – wie das Shop-Bild: Korpus hell, Leiste gefüllt in der Frontebene.
    // Gibt es nur bei PAX → kein tall-Test mehr (Felix 2026-10-13). Obere Seitenkante 23,9→30,2 mitzeichnen
    if (/leiste/.test(t)) return '<svg ' + a + '>' + ctx('M8 9H22M8 9V38H22M8 9L15 2H30V31L27 34M15 2V31H22M23 9L30 2') + '<rect x="22" y="9" width="5" height="29"/></svg>';
    // Seitenumkleidung = Seitenwand am Korpus, Korpus hell, Wand gefüllt (Shop-Bild: rechte Seite) – METOD am
    // Unterschrank, PAX am hohen Korpus. „mit Rundung“ (nur PAX) = Seitenwand mit Dicke 2, deren vordere Außenkante ein
    // Viertelkreis ist: er beginnt genau an der Korpus-Vorderkante (x 23) und läuft in die Seitenfläche – bündig mit der
    // Front, nichts steht vor (Felix 2026-10-13 mit Foto). Rundung grau, Deckel oben hell, Umriss nur einmal zeichnen.
    // Shop-Bild: Wand links bzw. rechts am Korpus → „rechts“ wie gezeichnet, sonst gespiegelt.
    // Rundung vor dem tall-Test, damit der Titel immer dieses Icon bekommt (Felix 2026-10-13). „Deckseite“ = Seitenwand.
    if (/seiten|deckseite|umkleidung|verkleidung/.test(t)) {
      if (/rundung/.test(t)) return '<svg ' + a + '>' + flip('<path d="M23 9C24.1 9 25.9 8.1 27 7L32 2H30Z" fill="#ECEBE5" stroke="none"/>' +
        ctx(pax + 'M23 9L30 2H32') + '<path d="M27 7L32 2V31L27 36Z" stroke="none"/>' +
        '<path d="M23 9C24.1 9 25.9 8.1 27 7V36C25.9 37.1 24.1 38 23 38Z" fill="#B9B7AD" stroke="none"/>' +
        '<path d="M32 2V31L27 36C25.9 37.1 24.1 38 23 38V9C24.1 9 25.9 8.1 27 7Z" fill="none"/>', !right) + '</svg>';
      if (!tall) return '<svg ' + a + '>' + ctx('M5 14H25V36H5ZM5 14L13 6H33M13 6V28H25') + '<path d="M25 14L33 6V28L25 36Z"/></svg>';
      return '<svg ' + a + '>' + ctx(pax) + '<path d="M23 9L30 2V31L23 38Z"/></svg>';
    }
    // Unterschrankpaneel = Unterseite (Boden) eines Oberschranks: Schrank als durchsichtiger Drahtrahmen von
    // schräg oben wie die Shop-Kachel „Unterschrankpaneele“, Bodenplatte gefüllt, Kanten darüber (Felix 2026-10-12)
    if (/paneel/.test(t)) return '<svg ' + a + '><path d="M2 35H28L38 25H12Z"/><g fill="none" stroke="#77756D" stroke-width="1.1" stroke-linecap="round"><path d="M2 35V15H28V35"/><path d="M2 15L12 5H38L28 15"/><path d="M12 5V25M38 5V25"/></g></svg>';
    if (/schublade/.test(t)) return '<svg ' + a + '><rect x="4" y="13" width="32" height="14"/><path d="M16 20h8" fill="none" stroke-linecap="round"/></svg>';
    if (/ausziehbar/.test(t)) return '<svg ' + a + '><rect x="10" y="4" width="20" height="32"/><path d="M16 9h8" fill="none" stroke-linecap="round"/></svg>';
    // Klappbare Ecktüren = Türpaar 2 × 25 × 80 für den L-förmigen Eckschrank 88 × 88: Blick in die Innenecke, Korpus hell.
    // Angeschlagener Flügel zu, freier Flügel (Punkt = Griff) um 20° zum Betrachter aufgeklappt wie im Shop-Bild „rechts“
    // → links/rechts unterscheiden sich in der Form, nicht nur im Punkt. „links“ = angeschlagen links (Felix 2026-10-13)
    if (/klappbar/.test(t)) return '<svg ' + a + '>' + flip(ctx('M12.5 18L2.5 12L20 1.5L37.5 12L27.5 18M2.5 12V30.5L12.5 36.5M37.5 12V30.5L27.5 36.5L20 32M20 13.5L27.5 18V36.5') +
      '<path d="M12.5 18L20 13.5V32L12.5 36.5Z"/><path d="M20 13.5L24.5 19.3V37.8L20 32Z" stroke="none"/>' +
      '<path d="M20 13.5L24.5 19.3V37.8L20 32" fill="none"/>' + dot(22.8, 26.3), right) + '</svg>';
    // Ecktür = eine Tür 60 × 80 am Eckschrank 128 × 68: Eckschrank im selben Blick in die Innenecke wie die klappbaren
    // Ecktüren, aber nur EINE flache Tür (Felix 2026-10-13). Tür-Seite breiter (60 statt 25), die andere Seite der Ecke
    // = Blindteil, hell getönt. Anschlag an der Ecke (Shop-Bild) → Punkt (Griff) außen; „links“ = Blindteil links
    if (/eck/.test(t)) return '<svg ' + a + '>' + flip('<path d="M12 15.6L16.5 12.9V31.4L12 34.1Z" fill="#ECEBE5" stroke="none"/>' +
      ctx('M16.5 12.9L12 15.6L2.5 9.9L16.5 1.5L37.5 14.1L28 19.8M2.5 9.9V28.4L12 34.1L16.5 31.4M12 15.6V34.1M37.5 14.1V32.6L28 38.3') +
      '<path d="M16.5 12.9L28 19.8V38.3L16.5 31.4Z"/>' + dot(25.9, 27.8), right) + '</svg>';
    if (/spül/.test(t)) return '<svg ' + a + '><rect x="8" y="4" width="24" height="32"/><path d="M12 9h16" fill="none" stroke-linecap="round"/></svg>';
    if (/waagerecht/.test(t)) return '<svg ' + a + '><rect x="4" y="10" width="32" height="20"/>' + dot(20, 26) + '</svg>';
    var y = tall ? 3 : 4, h = tall ? 34 : 32, w = tall ? 16 : 20, x = tall ? 12 : 10;
    // Tür-Erweiterung (METOD + 3 cm, PAX + 5,5 cm) = normale Tür, nur LÄNGER, nicht breiter: das Plus sitzt
    // unten (bei PAX verdeckt es den Sockel) → Körper exakt wie die normale Tür, darunter grauer Streifen mit
    // gestrichelter Kante (Felix 2026-10-12). Umriss nur einmal zeichnen (sonst dunkler als die anderen Icons).
    // Titel „Türen + 3 cm Erweiterung“ / „Tür(en) Erweiterungen + …“ treffen keinen Zweig darüber.
    if (/erweiterung/.test(t)) {
      var ey = tall ? 1 : 2, sy = ey + h, eh = h + (tall ? 4 : 5);
      return '<svg ' + a + '><rect x="' + x + '" y="' + ey + '" width="' + w + '" height="' + eh + '" stroke="none"/>' +
        '<rect x="' + x + '" y="' + sy + '" width="' + w + '" height="' + (eh - h) + '" fill="#B9B7AD" stroke="none"/>' +
        '<rect x="' + x + '" y="' + ey + '" width="' + w + '" height="' + eh + '" fill="none"/>' +
        '<path d="M' + x + ' ' + sy + 'h' + w + '" fill="none" stroke-dasharray="2 2"/>' +
        dot(right ? x + 4 : x + w - 4, ey + h / 2) + '</svg>';
    }
    return '<svg ' + a + '><rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '"/>' + dot(right ? x + 4 : x + w - 4, 20) + '</svg>';
  }

  var _origClose = P.closeModal;
  P.closeModal = function () {
    if (this._nf && this._nf.dirty && !this._nfForce) {
      this._nf.confirmClose = true;
      this.nfRender();
      var b = this.nfSheetRoot().querySelector('[data-nf-discard]');
      if (b) b.focus();
      return;
    }
    this._nfForce = false;
    this._nf = null;
    this._nfOpenSeq = (this._nfOpenSeq || 0) + 1;   // wartendes openModal verwerfen
    if (this.modal) this.modal.classList.remove('nf-sheet-mode', 'nf-wide', 'nf-multi');
    document.documentElement.classList.remove('nf-overlay-open');
    if (this._nfKeyHandler) { document.removeEventListener('keydown', this._nfKeyHandler); this._nfKeyHandler = null; }
    if (this._nfMql && this._nfMqlHandler) { try { this._nfMql.removeEventListener('change', this._nfMqlHandler); } catch (e) {} this._nfMqlHandler = null; }
    _origClose.call(this);
    if (this._nfReturnFocus && this._nfReturnFocus.focus) { try { this._nfReturnFocus.focus(); } catch (e) {} }
    this._nfReturnFocus = null;
  };
  P.nfClose = function (force) { this._nfForce = !!force; this.closeModal(); };
  P.nfIsWide = function () { return !!(window.matchMedia && window.matchMedia(WIDE).matches); };

  P.openModal = async function (sectionId, opts) {
    opts = opts || {};
    var cfg = this.nfSection(sectionId);
    if (!cfg) return;
    // jedes Öffnen/Schließen zählt weiter: eine ältere Fortsetzung (z. B. Griffe-Fenster während des Ladens
    // geöffnet und wieder geschlossen) zeichnet nach dem Warten nicht mehr in das jetzt offene Fenster
    var seq = this._nfOpenSeq = (this._nfOpenSeq || 0) + 1;
    this.currentSectionId = sectionId;
    this._nfReturnFocus = document.activeElement;
    this.nfShowModal();
    var root = this.nfSheetRoot();
    // Griffe (eigene Sammlung) heißen auch beim Laden so – nicht „Fronten“ (Felix 2026-09-30)
    var ownPool = this.sectionUsesOwnCollection(cfg);
    root.innerHTML = '<div class="nf-sheet__loading">' + esc((ownPool ? (cfg.sectionTitle || 'Produkte') : 'Fronten') + ' werden geladen …') + '</div>';
    var self = this;
    this._nfKeyHandler = function (e) {
      if (e.key === 'Escape') { self.closeModal(); return; }
      if (e.key === 'Tab') trapFocus(e, self.nfSheetRoot());
    };
    document.addEventListener('keydown', this._nfKeyHandler);

    // nur auf die Sammlung warten, die dieses Fenster braucht (Griffe laden parallel zu den Fronten) –
    // und auf eine laufende Wiederherstellung (Speicher, geteilter Link, „Bearbeiten“), sonst fehlt die
    // gespeicherte Auswahl im Fenster und geht beim Übernehmen verloren (restorePromise, nf-bundle-selector.js)
    await Promise.all([
      this.poolPromiseFor ? this.poolPromiseFor(cfg) : this.productsLoadedPromise,
      this.restorePromise
    ]);
    if (seq !== this._nfOpenSeq) return;   // inzwischen geschlossen oder ein anderes Fenster geöffnet
    this.lastToggledVariantByProduct = {};
    this.detectAndSetMainProductColor();
    this.detectAndSetMainProductBackground();
    this._nfLastColor = this.selectedColorFilter;

    // Häufige Arten zuerst, Ecken und Sonderfälle ans Ende (stabil innerhalb einer Stufe)
    var rank = function (p) {
      var t = String(self.getProductDisplayTitle(p) || '').toLowerCase();
      if (/klappbar/.test(t)) return 6;
      if (/eck/.test(t)) return 5;
      if (/erweiterung/.test(t)) return 4;
      if (/spül/.test(t)) return 3;
      if (/waagerecht/.test(t)) return 2;
      if (/ausziehbar/.test(t)) return 1;
      return 0;
    };
    var productsFor = function (c) {
      self.filterProductsForSection(c);
      return (self.availableProducts || []).filter(function (p) { return p && p.variants && p.variants.length; })
        .map(function (p, i) { return { p: p, i: i, r: rank(p) }; })
        .sort(function (x, y) { return x.r - y.r || x.i - y.i; })
        .map(function (x) { return x.p; });
    };
    // Fronten-Kategorien (Haupt-Collection) teilen sich ein Popup; Griffe (eigene Collection) bleiben einzeln
    var groupCfgs = this.sectionUsesOwnCollection(cfg)
      ? [cfg]
      : (this.sections || []).filter(function (c) { return !self.sectionUsesOwnCollection(c); });
    var groups = groupCfgs.map(function (c) { return { sectionId: c.sectionId, cfg: c, products: productsFor(c) }; })
      .filter(function (g) { return g.products.length || g.sectionId === sectionId; });
    var groupIds = groups.map(function (g) { return g.sectionId; });
    var draft = new Map();
    if (this.nfGriffRekey()) this.nfAfterChange();   // Schlüssel aus Speicher/Link vereinheitlicht → Liste neu
    this.selectedProducts.forEach(function (it, key) {
      if (groupIds.indexOf(it.sectionId) === -1) return;
      var d = { product: it.product, selectedVariant: it.selectedVariant, quantity: it.quantity || 1, sectionId: it.sectionId };
      var g = self.nfGriffOf(it, key);
      if (g) d.griff = g;
      draft.set(key, d);
    });
    // gpos: aktive Griffposition je Front-Art (Produkt-ID) – die Stepper zählen auf Variante + diese Position
    this._nf = { groups: groups, draft: draft, active: null, view: 'types', dirty: false, confirmClose: false, gpos: {} };
    this.nfSetSection(sectionId);
    var products = this._nf.products;

    var start = null;
    if (opts.editKey && draft.has(opts.editKey)) {
      var ed = draft.get(opts.editKey);
      start = ed.product;
      if (ed.griff) this._nf.gpos[start.id] = ed.griff;   // „Ändern“ öffnet in der Position dieser Zeile
    }
    else if (products.length === 1 && groups.length === 1) start = products[0];
    if (start) {
      this._nf.active = start.id;
      this._nf.view = 'sizes';
    }
    this._nfMql = window.matchMedia ? window.matchMedia(WIDE) : null;
    this._nfMqlHandler = function () { if (self._nf) self.nfRender(); };
    if (this._nfMql) { try { this._nfMql.addEventListener('change', this._nfMqlHandler); } catch (e) {} }
    this.nfRender();
    var first = this.nfSheetRoot().querySelector('.nf-type2, .nf-mrow button');
    if (first) first.focus({ preventScroll: true });
  };

  P.confirmSelection = function () { this.nfCommitDraft(); };

  P.nfSetSection = function (sectionId) {
    var st = this._nf;
    var g = st.groups.find(function (x) { return x.sectionId === sectionId; }) || st.groups[0];
    st.sectionId = g.sectionId; st.cfg = g.cfg; st.products = g.products;
    var self = this;
    var withSel = g.products.find(function (p) { return self.nfDraftCount(p.id) > 0; });
    st.active = g.products.length ? (withSel || g.products[0]).id : null; // Desktop zeigt rechts direkt Größen
  };
  P.nfMulti = function () { return !!(this._nf && this._nf.groups.length > 1); };
  P.nfSectionCount = function (sectionId) {
    var n = 0;
    this._nf.draft.forEach(function (it) { if (it.sectionId === sectionId) n += it.quantity || 0; });
    return n;
  };
  P.nfShortTitle = function (cfg) {
    var t = String((cfg && cfg.sectionTitle) || '');
    return /verkleidung/i.test(t) ? 'Verkleidung' : t;
  };

  // Griffe je Stil (Block-Einstellung griffe_style_rules): Hinweiszeile über der Griffe-Auswahl,
  // nur wenn für den Stil dieser Fronten eine Regel greift (z. B. „Für Liniert-Fronten passt der Griff Linea.“)
  P.nfRuleHintHtml = function (cfg) {
    if (!cfg || typeof this.styleRuleAppliesToSection !== 'function' || !this.styleRuleAppliesToSection(cfg)) return '';
    var t = this.getStyleRuleHint();
    if (!t) return '';
    return '<p class="nf-rule-hint"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5.5"/><circle cx="12" cy="7.6" r=".6" fill="currentColor"/></svg><span>' + esc(t) + '</span></p>';
  };

  // Hintergrund, auf den die Zeilen einer Front-Art gefiltert werden (null = nicht filtern):
  // nur Fronten aus der Haupt-Collection mit Option „Hintergrund …“, Wert aus Schritt 1
  // (Standard „Gleiche Farbe wie die Fronten“). Gibt es den Wert bei der Front nicht, nicht filtern.
  P.nfBgFilterFor = function (product, cfg) {
    var bi = bgIndex(product);
    if (bi === -1 || !cfg || this.sectionUsesOwnCollection(cfg)) return null;
    var bg = this.nfReadStepOneBg() || BG_DEFAULT;
    return product.variants.some(function (v) { return same(vOpt(v, bi), bg); }) ? bg : null;
  };

  P.nfCandidateVariants = function (product) {
    var cfg = this._nf ? this._nf.cfg : null;
    var locked = this.nfLockedColor(cfg);
    var ci = optIndex(product, COLOR_NAMES);
    // Ohne Hintergrund-Filter stand jede Größe 5× da (je Hintergrund) – die oberste Zeile „Gleiche Farbe …“
    // widersprach dann der Eigenschaft „Hintergrund Farbe“ aus Schritt 1
    var bi = bgIndex(product), bg = this.nfBgFilterFor(product, cfg);
    return product.variants.filter(function (v) {
      if (bg && !same(vOpt(v, bi), bg)) return false;
      return !(locked && ci !== -1 && !same(vOpt(v, ci), locked));
    });
  };

  P.nfProductById = function (id) {
    var st = this._nf;
    return st ? st.products.find(function (p) { return String(p.id) === String(id); }) || null : null;
  };

  P.nfDraftCount = function (productId, sectionId) {
    var n = 0;
    if (!this._nf) return 0;
    var sid = sectionId || this._nf.sectionId;
    this._nf.draft.forEach(function (it) { if (String(it.product.id) === String(productId) && (!sid || it.sectionId === sid)) n += qn(it.quantity); });
    return n;
  };

  P.nfDraftTotals = function (productId) {
    var c = 0, t = 0;
    if (!this._nf) return { count: 0, total: 0 };
    this._nf.draft.forEach(function (it) {
      if (productId != null && String(it.product.id) !== String(productId)) return;
      var q = qn(it.quantity);
      c += q; t += (parseInt(it.selectedVariant.price, 10) || 0) * q;
    });
    return { count: c, total: t };
  };

  // Zeilen einer Front-Art: je Variante (Farbe fest), Beschriftung aus den übrigen Optionen
  P.nfRowsFor = function (p) {
    var si = optIndex(p, SIZE_NAMES), ci = optIndex(p, COLOR_NAMES);
    var locked = this.nfLockedColor(this._nf.cfg);
    var bi = this.nfBgFilterFor(p, this._nf.cfg) ? bgIndex(p) : -1;   // gefilterter Hintergrund steht nicht in der Zeile
    var rows = this.nfCandidateVariants(p).map(function (v) {
      var parts = [];
      if (si !== -1) parts.push(prettySize(vOpt(v, si)));
      (p.options || []).forEach(function (o, i) {
        if (i === si || (i === ci && locked) || i === bi) return;
        var val = vOpt(v, i);
        if (val && val !== '-' && !/default title/i.test(val)) parts.push(val);
      });
      return { v: v, label: parts.join(' · ') || v.title, size: si !== -1 ? parseSize(vOpt(v, si)) : null };
    });
    rows.sort(function (a, b) {
      if (a.size && b.size) return a.size[0] - b.size[0] || a.size[1] - b.size[1] || a.label.localeCompare(b.label, 'de');
      if (a.size) return -1; if (b.size) return 1;
      return a.label.localeCompare(b.label, 'de');
    });
    return rows;
  };

  P.nfThumb = function (p) {
    var cfg = this._nf.cfg;
    if (this.sectionUsesOwnCollection(cfg)) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img && typeof img === 'object') img = img.src || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      return img ? '<img class="nf-type2__img" src="' + esc(img) + (img.indexOf('?') === -1 ? '?' : '&') + 'width=96" alt="" width="40" height="40">' : '<span class="nf-type2__img"></span>';
    }
    var tall = /pax|schrank/i.test(String(this.settings.productHandle || ''));
    return '<span class="nf-type2__icon">' + frontIcon(this.getProductDisplayTitle(p), tall) + '</span>';
  };

  P.nfHead = function (title, withBack) {
    var cfg = this._nf.cfg;
    var locked = this.nfLockedColor(cfg);
    var line = this.nfConfigLine();
    var html = '<div class="nf-sheet__grab" aria-hidden="true"></div>';
    html += '<div class="nf-sheet__head">';
    if (withBack) html += '<button type="button" class="nf-sheet__icon" data-nf-back aria-label="Zurück zu den Front-Arten"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>';
    html += '<h2 id="nf-sheet-title" class="nf-sheet__title">' + keepUnits(esc(title)) + '</h2>';
    if (locked && line && this.nfIsWide()) {
      html += '<span class="nf-sheet__config nf-sheet__config--inline"><span class="nf-swatch" style="' + esc(this.nfSwatchStyle(locked)) + '"></span><span>' + esc(line) + '</span><button type="button" class="nf-link" data-nf-change-color>Farbe ändern</button></span>';
    }
    html += '<button type="button" class="nf-sheet__icon" data-nf-close aria-label="Schließen"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    html += '</div>';
    if (locked && line && !this.nfIsWide()) {
      html += '<div class="nf-sheet__config"><span class="nf-swatch" style="' + esc(this.nfSwatchStyle(locked)) + '"></span><span>' + esc(line) + '</span><button type="button" class="nf-link" data-nf-change-color>Farbe ändern</button></div>';
    }
    return html;
  };

  P.nfTypesHtml = function (activeId, wide, group) {
    var self = this, st = this._nf;
    var g = group || { sectionId: st.sectionId, products: st.products };
    if (!g.products.length) return '<p class="nf-empty">Für diese Auswahl sind gerade keine Produkte verfügbar.</p>';
    var html = '<ul class="nf-types2" role="list">';
    g.products.forEach(function (p, idx) {
      var vs = self.nfCandidateVariants(p).filter(function (v) { return v.available !== false; });
      var n = self.nfDraftCount(p.id, g.sectionId);
      var min = vs.reduce(function (m, v) { var pr = parseInt(v.price, 10) || 0; return m === null || pr < m ? pr : m; }, null);
      var active = wide && g.sectionId === st.sectionId && String(p.id) === String(activeId);
      html += '<li><button type="button" class="nf-type2' + (active ? ' is-active' : '') + (n ? ' has-sel' : '') + '" data-nf-type="' + esc(g.sectionId) + '|' + idx + '"' + (vs.length ? '' : ' disabled') + (active ? ' aria-current="true"' : '') + '>';
      html += self.nfThumb(p);
      html += '<span class="nf-type2__name">' + keepUnits(esc(self.getProductDisplayTitle(p))) + '</span>';
      if (n) {
        html += '<span class="nf-badge">' + n + (wide ? '' : ' gewählt') + '</span>';
      } else if (!vs.length) {
        html += '<span class="nf-type2__meta">nicht verfügbar</span>';
      } else {
        html += '<span class="nf-type2__side"><span class="nf-type2__price">' + (vs.length > 1 ? 'ab ' : '') + money(min) + '</span>' + (wide ? '' : '<span class="nf-type2__meta">' + vs.length + (vs.length === 1 ? ' Größe' : ' Größen') + '</span>') + '</span>';
      }
      html += '</button></li>';
    });
    return html + '</ul>';
  };

  P.nfSizesHtml = function (p, wide) {
    var self = this, st = this._nf;
    var rows = this.nfRowsFor(p);
    var si = optIndex(p, SIZE_NAMES);
    // Griffposition: Picker setzt die aktive Position dieser Front-Art; Stepper zählen auf Variante + Position
    var gs = gSpec(p);
    var act = gs ? G.norm(st.gpos[p.id], gs) : '';
    var html = '';
    if (wide) {
      html += '<div class="nf-detail__head"><span class="nf-detail__title">' + esc(this.getProductDisplayTitle(p)) + '</span>';
      if (si !== -1) html += '<span class="nf-detail__help">Maße in cm, Breite × Höhe · <a class="nf-link" href="' + MEASURE_URL + '" target="_blank" rel="noopener">Ausmess-Anleitung</a></span>';
      html += '</div>';
    } else if (si !== -1) {
      html += '<p class="nf-help-line">Mengen direkt bei jeder Größe eintragen · <a class="nf-link" href="' + MEASURE_URL + '" target="_blank" rel="noopener">Welche Größe?</a></p>';
    }
    // Mengen derselben Größe in ANDEREN Positionen (Zeile darunter: „+ 2× Kante links“, Antippen wechselt den Picker)
    // und je Position für die Übersicht unter dem Picker (Befund M1: Kachel antippen fängt sonst still eine zweite Position an)
    var alt = {}, gcount = {};
    if (gs) {
      st.draft.forEach(function (it) {
        if (it.sectionId !== st.sectionId || String(it.product.id) !== String(p.id) || !(qn(it.quantity) > 0)) return;
        var g = G.norm(it.griff, gs);
        gcount[g] = (gcount[g] || 0) + qn(it.quantity);
        if (g === act) return;
        (alt[it.selectedVariant.id] = alt[it.selectedVariant.id] || []).push({ g: g, q: qn(it.quantity) });
      });
    }
    if (gs) {
      html += G.picker({ ctx: 'sheet:' + p.id, spec: gs, value: act });
      html += G.summary({ ctx: 'sheet:' + p.id, spec: gs, counts: gcount, active: act });
      if (st._gWarn && String(st._gWarn.pid) === String(p.id)) html += '<p class="nf-gwarn" role="alert">' + esc(st._gWarn.text) + '</p>';
    }
    if (!rows.length) return html + '<p class="nf-empty">In dieser Farbe ist gerade keine Größe verfügbar.</p>';
    html += '<ul class="nf-mrows' + (wide ? ' nf-mrows--grid' : '') + '" role="list">';
    rows.forEach(function (r) {
      var key = self.nfKey(st.sectionId, r.v, p, act);
      var d = st.draft.get(key);
      var q = d ? qn(d.quantity) : 0;
      var avail = r.v.available !== false;
      var pr = parseInt(r.v.price, 10) || 0, cp = parseInt(r.v.compare_at_price, 10) || 0;
      var fin = self.nfLockedColor(st.cfg) ? null : self.nfVariantFinish(p, r.v);
      var finStyle = fin && !fin.front ? self.nfFinishStyle(fin.name) : null;
      var rl = r.label + (act ? ', ' + G.label(act) : '');
      html += '<li class="nf-mrow' + (q ? ' is-on' : '') + (avail ? '' : ' is-na') + '">';
      if (finStyle) html += '<span class="nf-mrow__sw" style="' + esc(finStyle) + '" aria-hidden="true"></span>';
      html += '<span class="nf-mrow__text"><span class="nf-mrow__label">' + esc(r.label) + '</span>';
      html += '<span class="nf-mrow__price">' + (avail
        ? (q ? '<span class="nf-mrow__qty">' + q + ' ×</span> ' : '') + '<strong>' + money(pr) + '</strong>' + (cp > pr ? ' <s>' + money(cp) + '</s>' : '')
        : 'nicht verfügbar') + '</span>';
      // steht die Größe in mehreren Positionen: auch die gewählte beim Namen nennen (der Stepper zählt nur sie)
      if (q && alt[r.v.id] && alt[r.v.id].length) html += '<span class="nf-mrow__gcur">' + q + '× ' + esc(G.label(act)) + '</span>';
      (alt[r.v.id] || []).forEach(function (a) {
        html += '<button type="button" class="nf-link nf-mrow__gsw" data-nf-gswitch="' + esc(a.g) + '" data-nf-gpid="' + esc(p.id) + '" aria-label="' + esc(a.q + '× ' + r.label + ' mit ' + G.label(a.g) + ' gewählt – Griffposition ' + G.label(a.g) + ' anzeigen') + '">+ ' + a.q + '× ' + esc(G.label(a.g)) + '</button>';
      });
      html += '</span>';
      if (avail) {
        if (q) {
          html += '<span class="nf-stepper nf-stepper--sm" role="group" aria-label="Anzahl ' + esc(rl) + '">';
          html += '<button type="button" data-nf-dec="' + r.v.id + '" aria-label="' + (q === 1 ? esc(rl) + ' entfernen' : 'Eine weniger') + '">−</button><output>' + q + '</output>';
          html += '<button type="button" data-nf-inc="' + r.v.id + '" aria-label="Eine mehr">+</button></span>';
        } else {
          html += '<button type="button" class="nf-add" data-nf-inc="' + r.v.id + '" aria-label="' + esc(rl) + ' hinzufügen">+</button>';
        }
      }
      html += '</li>';
    });
    html += '</ul>';
    if (si !== -1) html += '<div class="nf-mrows__more"><a class="nf-link" href="' + CUSTOM_SIZE_URL + '" target="_blank" rel="noopener">Größe nicht dabei? Sondermaß anfragen</a></div>';
    return html;
  };

  P.nfFootHtml = function (active, wide) {
    var st = this._nf;
    if (st.confirmClose) {
      return '<div class="nf-sheet__foot nf-sheet__foot--confirm" role="alertdialog" aria-label="Änderungen nicht übernommen">' +
        '<p>Ihre Änderungen sind noch nicht übernommen.</p>' +
        '<div class="nf-sheet__btns"><button type="button" class="nf-btn nf-btn--ghost" data-nf-discard>Verwerfen</button>' +
        '<button type="button" class="nf-btn nf-btn--primary" data-nf-commit>Übernehmen</button></div></div>';
    }
    var all = this.nfDraftTotals(null);
    var multi = this.nfMulti();
    var self = this;
    var noun = multi ? (all.count === 1 ? 'Front' : 'Fronten') : nounFor(st.cfg.sectionTitle, all.count);
    var perGroup = multi ? st.groups.map(function (g) { var n = self.nfSectionCount(g.sectionId); return n ? esc(self.nfShortTitle(g.cfg)) + ' ' + n : ''; }).filter(Boolean).join(' · ') : '';
    var html = '<div class="nf-sheet__foot">';
    var showHere = !wide && st.view === 'sizes' && active;
    if (showHere) {
      var here = this.nfDraftTotals(active.id);
      html += '<div class="nf-sheet__sum"><span>Hier: ' + here.count + ' · ' + money(here.total) + '</span><strong>Gesamt: ' + all.count + ' ' + esc(noun) + ' · ' + money(all.total) + '</strong></div>';
    } else {
      html += '<div class="nf-sheet__sum"><span>' + (perGroup || 'Ihre Auswahl') + '</span><strong>' + (all.count ? all.count + ' ' + esc(noun) + ' · ' + money(all.total) : 'noch nichts gewählt') + '</strong></div>';
    }
    var label = all.count ? 'Alle ' + all.count + ' übernehmen' : (st.dirty ? 'Auswahl leeren' : 'Noch nichts gewählt');
    var disabled = !all.count && !st.dirty;
    html += '<div class="nf-sheet__btns">';
    if (showHere && (st.products.length > 1 || multi)) html += '<button type="button" class="nf-btn nf-btn--ghost" data-nf-back>Andere Art wählen</button>';
    html += '<button type="button" class="nf-btn nf-btn--primary" data-nf-commit' + (disabled ? ' disabled' : '') + '>' + esc(label) + '</button>';
    html += '</div></div>';
    return html;
  };

  P.nfRender = function () {
    var st = this._nf;
    if (!st) return;
    var root = this.nfSheetRoot();
    var wide = this.nfIsWide();
    this.modal.classList.toggle('nf-wide', wide);
    this.modal.classList.toggle('nf-multi', this.nfMulti());
    var scroll = {};
    root.querySelectorAll('[data-nf-scroll]').forEach(function (el) { scroll[el.getAttribute('data-nf-scroll')] = el.scrollTop; });
    var active = st.active != null ? this.nfProductById(st.active) : null;
    var html = '';
    var self = this;
    var multi = this.nfMulti();
    var title = multi ? 'Fronten wählen' : (st.cfg.sectionTitle || 'Fronten') + ' wählen';
    if (wide) {
      html += this.nfHead(title, false);
      html += '<div class="nf-sheet__cols">';
      html += '<div class="nf-sheet__list" data-nf-scroll="list">';
      if (multi) {
        st.groups.forEach(function (g) {
          if (!g.products.length) return;
          var n = self.nfSectionCount(g.sectionId);
          html += '<div class="nf-col-label">' + esc(self.nfShortTitle(g.cfg)) + (n ? ' <span class="nf-col-count">' + n + '</span>' : '') + '</div>' + self.nfTypesHtml(active && active.id, true, g);
        });
      } else {
        html += this.nfRuleHintHtml(st.cfg) + '<div class="nf-col-label">Art</div>' + this.nfTypesHtml(active && active.id, true);
      }
      html += '</div>';
      html += '<div class="nf-sheet__detail" data-nf-scroll="detail">' + (active ? this.nfSizesHtml(active, true) : '') + '</div>';
      html += '</div>';
    } else if (st.view === 'sizes' && active) {
      html += this.nfHead(this.getProductDisplayTitle(active), st.products.length > 1);
      html += '<div class="nf-sheet__body" data-nf-scroll="detail">' + this.nfRuleHintHtml(st.cfg) + this.nfSizesHtml(active, false) + '</div>';
    } else {
      html += this.nfHead(title, false);
      if (multi) {
        html += '<div class="nf-tabs" role="tablist" aria-label="Kategorie">';
        st.groups.forEach(function (g) {
          var n = self.nfSectionCount(g.sectionId);
          var on = g.sectionId === st.sectionId;
          html += '<button type="button" role="tab" aria-selected="' + on + '" class="nf-tab' + (on ? ' is-on' : '') + '" data-nf-section="' + esc(g.sectionId) + '">' + esc(self.nfShortTitle(g.cfg)) + (n ? ' <span class="nf-tab__n">' + n + '</span>' : '') + '</button>';
        });
        html += '</div>';
      }
      html += '<div class="nf-sheet__body" data-nf-scroll="list">' + (multi ? '' : this.nfRuleHintHtml(st.cfg)) + this.nfTypesHtml(null, false) + '</div>';
    }
    html += this.nfFootHtml(active, wide);
    root.innerHTML = html;
    root.querySelectorAll('[data-nf-scroll]').forEach(function (el) {
      var k = el.getAttribute('data-nf-scroll');
      if (scroll[k] != null && st._keepScroll) el.scrollTop = scroll[k];
    });
    st._keepScroll = false;
  };

  P.nfSheetChange = function () {};

  P.nfSheetClick = function (e) {
    var t = e.target.closest('button, a');
    var st = this._nf;
    if (!t || !st) return;
    var self = this;
    if (t.hasAttribute('data-nf-close')) { e.preventDefault(); this.closeModal(); return; }
    // Griffposition: Kachel im Picker bzw. „+ 2× Kante links“ unter einer Größe → aktive Position der Front-Art
    var gh = G && G.hit(e);
    if (gh && gh.ctx.indexOf('sheet:') === 0) {
      e.preventDefault();
      if (gh.disabled) return;
      var gpid = gh.ctx.slice(6);
      st.gpos[gpid] = gh.code; st.confirmClose = false; st._keepScroll = true;
      this.nfRender();
      G.focus(this.nfSheetRoot(), gh.ctx, gh.code);
      return;
    }
    var gall = G && G.allHit(e);
    if (gall && gall.indexOf('sheet:') === 0) {
      e.preventDefault();
      var apid = gall.slice(6), res = this.nfDraftMoveAll(apid);
      st.confirmClose = false; st._keepScroll = true;
      if (res.blocked) st._gWarn = { pid: apid, text: res.blocked };
      else if (res.n) st.dirty = true;
      this.nfRender();
      st._gWarn = null;
      G.focus(this.nfSheetRoot(), gall);
      return;
    }
    if (t.hasAttribute('data-nf-gswitch')) {
      e.preventDefault();
      var gctx = 'sheet:' + t.getAttribute('data-nf-gpid');
      st.gpos[t.getAttribute('data-nf-gpid')] = t.getAttribute('data-nf-gswitch'); st.confirmClose = false; st._keepScroll = true;
      this.nfRender();
      var gbox = this.nfSheetRoot().querySelector('[data-nfg="' + (window.CSS && CSS.escape ? CSS.escape(gctx) : gctx) + '"]');
      if (gbox && gbox.scrollIntoView) gbox.scrollIntoView({ block: 'nearest' });
      G.focus(this.nfSheetRoot(), gctx);
      return;
    }
    if (t.hasAttribute('data-nf-discard')) { e.preventDefault(); this.nfClose(true); return; }
    if (t.hasAttribute('data-nf-commit')) { e.preventDefault(); this.nfCommitDraft(); return; }
    if (t.hasAttribute('data-nf-back')) {
      e.preventDefault();
      st.view = 'types'; st.confirmClose = false;
      this.nfRender();
      var cur = this.nfSheetRoot().querySelector('.nf-type2.has-sel, .nf-type2');
      if (cur) cur.focus({ preventScroll: true });
      return;
    }
    if (t.hasAttribute('data-nf-section')) {
      e.preventDefault();
      this.nfSetSection(t.getAttribute('data-nf-section'));
      st.view = 'types'; st.confirmClose = false;
      this.nfRender();
      var tab = this.nfSheetRoot().querySelector('.nf-tab.is-on');
      if (tab) tab.focus({ preventScroll: true });
      return;
    }
    if (t.hasAttribute('data-nf-type')) {
      e.preventDefault();
      var parts = String(t.getAttribute('data-nf-type')).split('|');
      if (parts[0] !== st.sectionId) this.nfSetSection(parts[0]);
      var p = st.products[parseInt(parts[1], 10)];
      if (!p) return;
      st.active = p.id; st.confirmClose = false;
      if (!this.nfIsWide()) st.view = 'sizes';
      else st._keepScroll = true;
      this.nfRender();
      var d = this.nfSheetRoot().querySelector(this.nfIsWide() ? '.nf-type2.is-active' : '.nf-mrow button');
      if (d) d.focus({ preventScroll: true });
      if (this.nfIsWide()) { var det = this.nfSheetRoot().querySelector('.nf-sheet__detail'); if (det) det.scrollTop = 0; }
      return;
    }
    if (t.hasAttribute('data-nf-change-color')) {
      e.preventDefault();
      if (st.dirty) { st.confirmClose = true; this.nfRender(); return; }
      this.nfClose(true);
      var head = document.querySelector('.nf-acc .nf-acc__head');
      if (head && head.getAttribute('aria-expanded') !== 'true') head.click();
      var acc1 = head && head.closest('.nf-acc');
      (acc1 || document.querySelector('[data-nf-variant-picker]') || document.body).scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var inc = t.getAttribute('data-nf-inc'), dec = t.getAttribute('data-nf-dec');
    if (inc || dec) {
      e.preventDefault();
      var vid = inc || dec;
      var prod = null, variant = null;
      st.products.some(function (pp) {
        var v = pp.variants.find(function (x) { return String(x.id) === String(vid); });
        if (v) { prod = pp; variant = v; return true; }
        return false;
      });
      if (!variant) return;
      var gsp = gSpec(prod), gact = gsp ? G.norm(st.gpos[prod.id], gsp) : '';
      var key = this.nfKey(st.sectionId, variant, prod, gact);
      var cur2 = st.draft.get(key);
      if (inc) {
        if (cur2) cur2.quantity = Math.min(99, (cur2.quantity || 0) + 1);
        else {
          var nd = { product: prod, selectedVariant: variant, quantity: 1, sectionId: st.sectionId };
          if (gact) nd.griff = gact;
          st.draft.set(key, nd);
        }
      } else if (cur2) {
        cur2.quantity = (cur2.quantity || 1) - 1;
        if (cur2.quantity <= 0) st.draft.delete(key);
      }
      st.dirty = true; st.confirmClose = false; st._keepScroll = true;
      this.nfRender();
      var sel = inc ? '[data-nf-inc="' + vid + '"]' : '[data-nf-dec="' + vid + '"]';
      var again = this.nfSheetRoot().querySelector(sel) || this.nfSheetRoot().querySelector('[data-nf-inc="' + vid + '"]');
      if (again) again.focus({ preventScroll: true });
    }
  };

  P.nfCommitDraft = function () {
    var st = this._nf;
    if (!st) return;
    var draft = st.draft;
    var ids = st.groups.map(function (g) { return g.sectionId; });
    var sid = st.sectionId;
    var merged = new Map();
    this.selectedProducts.forEach(function (it, key) {
      if (ids.indexOf(it.sectionId) === -1) { merged.set(key, it); return; }
      if (draft.has(key)) merged.set(key, draft.get(key));
    });
    var added = [];
    draft.forEach(function (it, key) { if (!merged.has(key)) { merged.set(key, it); added.push(key); } });
    this.selectedProducts = merged;
    this.nfClose(true);
    this.nfAfterChange(ids);
    var self = this;
    added.forEach(function (k) {
      var row = self.scopedQuery('[data-nf-key="' + (window.CSS && CSS.escape ? CSS.escape(k) : k) + '"]');
      if (row) { row.classList.add('is-new'); setTimeout(function () { row.classList.remove('is-new'); }, 1600); }
    });
    var list = this.scopedQuery('[data-selected-products][data-section-id="' + sid + '"]');
    if (list) list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  /* ------------------------------------------------------------------ */
  /* Schritt-2-Liste                                                     */
  /* ------------------------------------------------------------------ */

  P.renderSelectedProductsForSection = function (sectionId) {
    var container = this.scopedQuery('[data-selected-products][data-section-id="' + sectionId + '"]');
    if (!container) return;
    var self = this;
    var cfg = this.nfSection(sectionId) || {};
    var locked = this.nfLockedColor(cfg);
    var items = [];
    this.selectedProducts.forEach(function (it, key) { if (it.sectionId === sectionId) items.push([key, it]); });
    // Mehrere Front-Kategorien: eine flache Liste ohne Unter-Akkordeons, ein gemeinsamer Button
    var flat = this.nfFlatIds().indexOf(sectionId) !== -1;

    var html = this.nfRuleHintHtml(cfg);
    if (flat) {
      html += '<div class="nf-flat__cap">' + esc(this.nfShortTitle(cfg)) + '</div>';
      if (!items.length) html += '<p class="nf-flat__hint">Noch nichts gewählt' + (/verkleidung/i.test(cfg.sectionTitle || '') ? ' – Sockel, Seitenteile, Paneele' : '') + ' · <button type="button" class="nf-link" data-open-modal data-section-id="' + esc(sectionId) + '">hinzufügen</button></p>';
    }
    if (items.length) {
      html += '<ul class="nf-sel" role="list">';
      items.forEach(function (kv) {
        var key = kv[0], it = kv[1];
        var q = qn(it.quantity) || 1;
        var price = parseInt(it.selectedVariant.price, 10) || 0;
        var color = self.nfItemColor(it);
        var off = locked && color && !same(color, locked);
        var fin = self.nfVariantFinish(it.product, it.selectedVariant);
        if (!color && fin) color = fin.name;
        var swStyle = fin && !fin.front ? (self.nfFinishStyle(fin.name) || self.nfSwatchStyle(color)) : self.nfSwatchStyle(color);
        var cmp = parseInt(it.selectedVariant.compare_at_price, 10) || 0;
        var si = optIndex(it.product, SIZE_NAMES);
        var size = si === -1 ? '' : prettySize(vOpt(it.selectedVariant, si));
        var gs = gSpec(it.product), gc = gs ? self.nfGriffOf(it, key) : '';
        html += '<li class="nf-sel__row' + (gs ? ' nf-sel__row--g' : '') + '" data-nf-key="' + esc(key) + '"><span class="bundle-selected-product" style="display:none"></span>';
        html += '<span class="nf-sel__sw" style="' + esc(swStyle) + '" aria-hidden="true"></span>';
        html += '<span class="nf-sel__text"><span class="nf-sel__name">' + esc(self.getProductDisplayTitle(it.product)) + '</span>';
        // Position steht im Chip darunter – in der Meta-Zeile wäre sie doppelt und schnitte mobil die Farbe ab (Befund N3)
        html += '<span class="nf-sel__meta">' + [size, color].filter(Boolean).map(esc).join(' · ') + '</span>';
        if (off) html += '<span class="nf-sel__warn">Andere Farbe als in Schritt 1</span>';
        html += '</span>';
        html += '<span class="nf-sel__sum">' + (cmp > price ? '<s>' + money(cmp * q) + '</s>' : '') + '<strong>' + money(price * q) + '</strong></span>';
        // Griffposition: Chip „Griff: Kante oben ▾“ öffnet den Picker darunter; ein Wechsel verschiebt die ganze Zeile
        if (gs) {
          var open = self._nfGOpen === key, popId = 'nf-gpop-' + sectionId + '-' + String(key).replace(/[^a-zA-Z0-9_-]/g, '');
          html += '<div class="nf-sel__grip">' + G.chip({ ctx: 'row:' + key, spec: gs, value: gc, expanded: open, controls: popId });
          if (open) html += '<div class="nfg-pop" id="' + popId + '">' + G.picker({ ctx: 'row:' + key, spec: gs, value: gc, compact: true }) + '</div>';
          if (self._nfGWarn === key) html += '<span class="nf-sel__warn nf-sel__gwarn" role="alert">' + esc(G.label(self._nfGWarnCode)) + ' hat schon ' + self._nfGWarnHave + ' – zusammen wären es mehr als 99. Bitte zuerst eine Zeile verringern.</span>';
          html += '</div>';
        }
        html += '<span class="nf-sel__bottom"><span class="nf-sel__sub">' + q + ' × ' + money(price) + ' · <button type="button" class="nf-link nf-sel__edit" data-nf-edit="' + esc(key) + '">Ändern</button></span>';
        html += '<span class="nf-stepper nf-stepper--sm nf-sel__ctl" role="group" aria-label="Anzahl ' + esc(self.nfRowLabel(it, key)) + '">';
        html += '<button type="button" data-nf-row-qty="-1" data-key="' + esc(key) + '" aria-label="' + (q <= 1 ? 'Entfernen' : 'Eine weniger') + '">' + (q <= 1 ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>' : '−') + '</button>';
        html += '<output>' + q + '</output>';
        html += '<button type="button" data-nf-row-qty="1" data-key="' + esc(key) + '" aria-label="Eine mehr">+</button></span></span>';
        html += '</li>';
      });
      html += '</ul>';
    }
    var noun = nounFor(cfg.sectionTitle, 2);
    if (!flat) html += '<button type="button" class="nf-sel__add" data-open-modal data-section-id="' + esc(sectionId) + '">+ ' + (items.length ? 'Weitere ' + esc(noun) + ' hinzufügen' : esc(cfg.sectionTitle || 'Produkte') + ' wählen') + '</button>';
    container.innerHTML = html;
    container.classList.add('nf-sel-container');
    var acc = container.closest('.bundle-accordion');
    if (acc) acc.classList.toggle('nf-flat', flat);
    if (flat) this.nfEnsureFrontsCta();

    if (!container._nfBound) {
      container._nfBound = true;
      var cssEsc = function (s) { return window.CSS && CSS.escape ? CSS.escape(s) : s; };
      container.addEventListener('keydown', function (e) {
        if (!G) return;
        if (G.onKey(e)) return;
        // Escape im offenen Griff-Picker: schließen, Fokus zurück auf den Chip
        if (e.key === 'Escape' && self._nfGOpen && e.target.closest && e.target.closest('.nfg-pop, [data-nfg-chip]')) {
          e.preventDefault(); e.stopPropagation();
          var k0 = self._nfGOpen; self._nfGOpen = null;
          self.renderSelectedProductsForSection(sectionId);
          var c0 = container.querySelector('[data-nfg-chip="row:' + cssEsc(k0) + '"]');
          if (c0) c0.focus({ preventScroll: true });
        }
      });
      container.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        // Griffposition: Chip auf/zu, Kachel = ganze Zeile auf diese Position verschieben
        if (G && b.hasAttribute('data-nfg-chip')) {
          e.preventDefault();
          var ck = b.getAttribute('data-nfg-chip').slice(4);
          var prevSec = self._nfGOpen ? String(self._nfGOpen).split('_')[0] : '';
          self._nfGOpen = self._nfGOpen === ck ? null : ck;
          if (prevSec && prevSec !== sectionId) self.renderSelectedProductsForSection(prevSec);   // dort offenen Picker schließen
          self.renderSelectedProductsForSection(sectionId);
          if (self._nfGOpen) G.focus(container, 'row:' + ck);
          else { var c1 = container.querySelector('[data-nfg-chip="row:' + cssEsc(ck) + '"]'); if (c1) c1.focus({ preventScroll: true }); }
          return;
        }
        var gh = G && G.hit(e);
        if (gh && gh.ctx.indexOf('row:') === 0) {
          e.preventDefault();
          if (gh.disabled) return;
          var gfrom = gh.ctx.slice(4);
          var nk = self.nfMoveGriff(gfrom, gh.code);
          if (nk === null) {   // Zielzeile + diese Zeile > 99: Picker zu, Hinweis an der Zeile
            var tgt = self.selectedProducts.get(self.nfKey(sectionId, self.selectedProducts.get(gfrom).selectedVariant, self.selectedProducts.get(gfrom).product, gh.code));
            self._nfGOpen = null; self._nfGWarn = gfrom; self._nfGWarnCode = gh.code; self._nfGWarnHave = tgt ? qn(tgt.quantity) : 0;
            self.renderSelectedProductsForSection(sectionId);
            self._nfGWarn = null;
            var c0 = container.querySelector('[data-nfg-chip="row:' + cssEsc(gfrom) + '"]');
            if (c0) c0.focus({ preventScroll: true });
            return;
          }
          self._nfGOpen = null;
          self.nfAfterChange([sectionId]);
          var c2 = container.querySelector('[data-nfg-chip="row:' + cssEsc(nk) + '"]');
          if (c2) c2.focus({ preventScroll: true });
          var row2 = c2 && c2.closest('.nf-sel__row');
          if (row2) { row2.classList.add('is-new'); setTimeout(function () { row2.classList.remove('is-new'); }, 1600); }
          return;
        }
        if (b.hasAttribute('data-open-modal')) { e.preventDefault(); e.stopPropagation(); self.openModal(b.getAttribute('data-section-id')); return; }
        if (b.hasAttribute('data-nf-edit')) { e.preventDefault(); self.openModal(sectionId, { editKey: b.getAttribute('data-nf-edit') }); return; }
        if (b.hasAttribute('data-nf-row-qty')) {
          e.preventDefault();
          var k = b.getAttribute('data-key');
          var it2 = self.selectedProducts.get(k);
          if (!it2) return;
          var nq = (it2.quantity || 1) + parseInt(b.getAttribute('data-nf-row-qty'), 10);
          if (nq <= 0) self.selectedProducts.delete(k); else it2.quantity = Math.min(99, nq);
          self.nfAfterChange([sectionId]);
          var again = container.querySelector('[data-nf-row-qty="' + b.getAttribute('data-nf-row-qty') + '"][data-key="' + (window.CSS && CSS.escape ? CSS.escape(k) : k) + '"]');
          if (again) again.focus({ preventScroll: true });
        }
      }, true);
    }
    this.updateBundleAddToCartButton();
  };

  // Front-Kategorien aus der Hauptkollektion (Schubladen, Türen, Verkleidung); Griffe bleiben eigener Schritt
  P.nfFlatIds = function () {
    var self = this;
    var ids = (this.sections || []).filter(function (c) { return !self.sectionUsesOwnCollection(c); }).map(function (c) { return c.sectionId; });
    return ids.length > 1 ? ids : [];
  };

  P.nfEnsureFrontsCta = function () {
    var ids = this.nfFlatIds();
    if (!ids.length) return;
    var self = this;
    var accs = ids.map(function (id) { return self.scopedQuery('.bundle-accordion[data-section-id="' + id + '"]'); }).filter(Boolean);
    if (!accs.length) return;
    var last = accs[accs.length - 1];
    var wrap = last.parentNode;
    var n = 0;
    this.selectedProducts.forEach(function (it) { if (ids.indexOf(it.sectionId) !== -1) n += it.quantity || 0; });
    wrap.classList.toggle('nf-flat-none', n === 0);
    var cta = wrap.querySelector(':scope > .nf-fronts-cta');
    if (!cta) {
      cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'nf-sel__add nf-fronts-cta';
      cta.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var start = ids.find(function (id) { return /tür/i.test((self.nfSection(id) || {}).sectionTitle || ''); }) || ids[0];
        self.openModal(start);
      });
    }
    if (cta.previousElementSibling !== last) wrap.insertBefore(cta, last.nextSibling);
    var label = n ? 'Fronten hinzufügen oder ändern' : '+ Fronten wählen';
    if (cta.textContent !== label) cta.textContent = label;
  };

  // Entfernen aus alten Codepfaden (Modal-Vorschau) auf die neue Liste umleiten
  var _origRemove = P.removeSelectedProduct;
  P.removeSelectedProduct = function (variantId, sectionId) {
    _origRemove.call(this, variantId, sectionId);
    this.nfAfterChange([sectionId]);
  };

  /* ------------------------------------------------------------------ */
  /* Farbwechsel-Dialog                                                  */
  /* ------------------------------------------------------------------ */

  P.nfWatchColor = function () {
    var self = this;
    var handler = function () {
      clearTimeout(self._nfColorT);
      self._nfColorT = setTimeout(function () { self.nfCheckColorChange(); }, 250);
    };
    window.addEventListener('themeVariantUpdated', handler);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-nf-variant-picker]')) {
        // echte Auswahl des Kunden beendet ein laufendes „Abbrechen“ (eigener Klick: _nfOwnClick;
        // das change-Ereignis aus element.click() gilt in Chrome als isTrusted)
        if (!self._nfOwnClick) self._nfRestore = null;
        handler();
      }
    }, true);
    Promise.resolve(this.productsLoadedPromise).then(function () {
      self.detectAndSetMainProductColor();
      self._nfLastColor = self.selectedColorFilter;
      self._nfLastBg = self.nfReadStepOneBg();
      self.nfAfterChange();
    });
  };

  // Radio der Farbe in Schritt 1 (der Picker wird vom Theme bei jedem Wechsel ersetzt → immer neu suchen)
  P.nfStepOneRadio = function (color) {
    var picker = document.querySelector('[data-nf-variant-picker]');
    if (!picker || !color) return null;
    var inputs = Array.prototype.slice.call(picker.querySelectorAll('input[type="radio"]'));
    var val = function (r) { return radioColor(r) || r.value; };
    return inputs.find(function (r) { return same(val(r), color); }) ||
           inputs.find(function (r) { return normColor(val(r)) === normColor(color); }) || null;
  };
  P.nfClickStepOne = function (r) {
    if (!r || r.checked) return false;
    this._nfOwnClick = true;
    try { r.click(); } finally { this._nfOwnClick = false; }
    return true;
  };

  // „Abbrechen“ im Farbwechsel-Dialog: Schritt 1 wieder auf die vorherige Farbe stellen.
  // Der Klick löst den normalen Theme-Ablauf aus (Galerie, URL, Varianten-ID). Eine noch laufende
  // Antwort für die abgebrochene Farbe kann den Picker danach wieder ersetzen – nfCheckColorChange
  // stellt dann erneut zurück, solange _nfRestore aktiv ist (endet bei echter Auswahl oder nach 10 s).
  P.nfRestoreStepOneColor = function (color) {
    if (!color) return;
    this._nfRestore = { color: color, until: Date.now() + 10000, tries: 0 };
    this._nfLastColor = color;
    this.nfClickStepOne(this.nfStepOneRadio(color));
    this.selectedColorFilter = null;
    this.detectAndSetMainProductColor();
    this.nfAfterChange();
  };

  // Hintergrund der Griffe in Schritt 1 geändert → gewählte Fronten (gleiche Größe und Farbe) mitnehmen,
  // sonst widerspricht die Variante („Gleiche Farbe …“) dem Hintergrund der Zusammenstellung
  P.nfCheckBgChange = function () {
    var now = this.nfReadStepOneBg();
    if (!now) return;
    var prev = this._nfLastBg;
    this._nfLastBg = now;
    if (!prev || same(prev, now)) return;
    var res = this.nfSwapBackground(now);
    if (res.missing.length) this.showNotification(res.missing.length + ' Position(en) gibt es nicht mit „' + now + '“ – sie bleiben unverändert.', 6000);
    else if (res.n) this.showNotification((res.n === 1 ? '1 Front' : res.n + ' Fronten') + ' auf „' + now + '“ umgestellt.');
  };

  P.nfCheckColorChange = function () {
    this.nfCheckBgChange();
    var prev = this._nfLastColor;
    this.detectAndSetMainProductColor();
    var now = this.selectedColorFilter;
    var rs = this._nfRestore;
    if (rs && Date.now() > rs.until) rs = this._nfRestore = null;
    if (rs && now && !same(now, rs.color)) {
      // verspätete Theme-Antwort der abgebrochenen Farbe → wieder zurückstellen statt neu zu fragen
      if (rs.tries++ < 3) {
        if (this.nfClickStepOne(this.nfStepOneRadio(rs.color))) { this.detectAndSetMainProductColor(); return; }
      }
      this._nfRestore = null;
    }
    if (!now || same(prev, now)) return;
    this._nfLastColor = now;
    var self = this, affected = [];
    this.selectedProducts.forEach(function (it, key) {
      var cfg = self.nfSection(it.sectionId);
      if (!self.nfLockedColor(cfg)) return;
      var c = self.nfItemColor(it);
      if (c && !same(c, now)) affected.push(key);
    });
    // Liste neu zeichnen (Hinweis "Andere Farbe")
    this.nfAfterChange();
    if (affected.length) this.nfColorDialog(prev, now, affected);
  };

  // Gewählte Positionen auf eine andere Variante umstellen: gleiche Optionen, nur Option idxOf(product)
  // = value. pick(it, key) wählt die betroffenen Positionen. Nicht vorhandene bleiben und werden gemeldet.
  P.nfSwapOption = function (pick, idxOf, value) {
    var self = this, missing = [], n = 0;
    var merged = new Map();
    // griff: Griffposition wandert mit (Schlüssel = Variante + Position)
    var put = function (k, product, variant, qty, sectionId, griff) {
      var cur = merged.get(k);
      if (cur) cur.quantity = Math.min(99, cur.quantity + qty);
      else {
        var e = { product: product, selectedVariant: variant, quantity: qty, sectionId: sectionId };
        if (griff) e.griff = griff;
        merged.set(k, e);
      }
    };
    this.selectedProducts.forEach(function (it, key) {
      var p = it.product, oi = idxOf(p);
      var g = self.nfGriffOf(it, key);
      if (oi === -1 || !pick(it, key)) { put(key, it.product, it.selectedVariant, it.quantity || 1, it.sectionId, g); return; }
      var target = p.variants.find(function (v) {
        if (v.available === false) return false;
        for (var i = 0; i < (p.options || []).length; i++) {
          var want = i === oi ? value : vOpt(it.selectedVariant, i);
          if (!same(vOpt(v, i), want)) return false;
        }
        return true;
      });
      if (!target) { missing.push(self.nfItemLabel(it)); put(key, it.product, it.selectedVariant, it.quantity || 1, it.sectionId, g); return; }
      n += it.quantity || 1;
      put(self.nfKey(it.sectionId, target, p, g), p, target, it.quantity || 1, it.sectionId, g);
    });
    this.selectedProducts = merged;
    this.nfAfterChange();
    return { missing: missing, n: n };
  };

  P.nfSwapColor = function (keys, color) {
    return this.nfSwapOption(function (it, key) { return keys.indexOf(key) !== -1; },
      function (p) { return optIndex(p, COLOR_NAMES); }, color).missing;
  };

  // Hintergrund: nur Fronten aus der Haupt-Collection, deren Hintergrund abweicht
  P.nfSwapBackground = function (bg) {
    var self = this;
    return this.nfSwapOption(function (it) {
      var cfg = self.nfSection(it.sectionId);
      return !!cfg && !self.sectionUsesOwnCollection(cfg) && !same(vOpt(it.selectedVariant, bgIndex(it.product)), bg);
    }, bgIndex, bg);
  };

  P.nfColorDialog = function (prev, now, keys) {
    var self = this;
    var n = keys.reduce(function (s, k) { var it = self.selectedProducts.get(k); return s + ((it && it.quantity) || 1); }, 0);
    var old = document.querySelector('.nf-dialog');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'nf-dialog';
    el.innerHTML =
      '<div class="nf-dialog__backdrop" data-nf-dlg-cancel></div>' +
      '<div class="nf-dialog__panel" role="dialog" aria-modal="true" aria-labelledby="nf-dlg-title">' +
      '<div class="nf-dialog__head"><span class="nf-dialog__sw" style="' + esc(this.nfSwatchStyle(prev)) + '"></span><span class="nf-dialog__sw nf-dialog__sw--2" style="' + esc(this.nfSwatchStyle(now)) + '"></span>' +
      '<h2 id="nf-dlg-title">Farbe auf ' + esc(now) + ' ändern?</h2></div>' +
      '<p>Sie haben schon ' + n + ' ' + (n === 1 ? 'Front' : 'Fronten') + ' in ' + esc(prev || 'einer anderen Farbe') + ' gewählt.</p>' +
      '<fieldset><legend class="nf-visually-hidden">Was soll mit Ihren Fronten passieren?</legend>' +
      '<label class="nf-choice is-checked"><input type="radio" name="nf-scope" value="all" checked><span><strong>Alle ' + n + ' auf ' + esc(now) + ' umstellen</strong><small>Größen und Anzahl bleiben gleich</small></span></label>' +
      '<label class="nf-choice"><input type="radio" name="nf-scope" value="new"><span><strong>Nur für neue Fronten verwenden</strong><small>Die gewählten bleiben ' + esc(prev || 'wie sie sind') + '</small></span></label>' +
      '</fieldset>' +
      '<div class="nf-dialog__actions"><button type="button" class="nf-btn nf-btn--ghost" data-nf-dlg-cancel>Abbrechen</button><button type="button" class="nf-btn nf-btn--primary" data-nf-dlg-ok>Übernehmen</button></div>' +
      '</div>';
    document.body.appendChild(el);
    document.documentElement.classList.add('nf-overlay-open');
    var ret = document.activeElement;
    var close = function () { el.remove(); document.documentElement.classList.remove('nf-overlay-open'); document.removeEventListener('keydown', onKey); if (ret && ret.focus) try { ret.focus(); } catch (e) {} };
    // Abbrechen (Knopf, Hintergrund, Escape): Zustand wie vor dem Klick – vorherige Farbe in Schritt 1,
    // Galerie und Liste ohne „Andere Farbe“-Hinweise
    var cancel = function () {
      close();
      if (prev) self.nfRestoreStepOneColor(prev);
      ret = self.nfStepOneRadio(prev) || ret;
      if (ret && ret.focus) try { ret.focus(); } catch (e) {}
      // Das Theme ersetzt den Farb-Picker nach dem Zurückstellen (Antwort kommt später) – der fokussierte
      // Knopf ist dann weg und der Fokus fällt auf <body>. Kurz nachfassen, bis der neue Picker steht;
      // jede eigene Eingabe beendet das.
      if (prev) {
        var until = Date.now() + 4000, stop = false;
        var quit = function () { stop = true; };
        document.addEventListener('pointerdown', quit, { capture: true, once: true });
        document.addEventListener('keydown', quit, { capture: true, once: true });
        var refocus = function () {
          if (stop || Date.now() > until) {
            document.removeEventListener('pointerdown', quit, true);
            document.removeEventListener('keydown', quit, true);
            return;
          }
          var a = document.activeElement;
          if (!a || a === document.body || !a.isConnected) {
            var r = self.nfStepOneRadio(prev);
            if (r && r.focus) try { r.focus({ preventScroll: true }); } catch (e) {}
          }
          setTimeout(refocus, 120);
        };
        setTimeout(refocus, 120);
      }
    };
    var onKey = function (e) {
      if (e.key === 'Escape') { cancel(); return; }
      if (e.key === 'Tab') trapFocus(e, el.querySelector('.nf-dialog__panel'));
    };
    document.addEventListener('keydown', onKey);
    el.addEventListener('change', function () {
      el.querySelectorAll('.nf-choice').forEach(function (l) { l.classList.toggle('is-checked', l.querySelector('input').checked); });
    });
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-nf-dlg-cancel]')) { cancel(); return; }
      if (e.target.closest('[data-nf-dlg-ok]')) {
        var scope = el.querySelector('input[name="nf-scope"]:checked').value;
        close();
        if (scope === 'all') {
          var missing = self.nfSwapColor(keys, now);
          if (missing.length) self.showNotification(missing.length + ' Position(en) gibt es nicht in ' + now + ' – sie bleiben unverändert.');
        }
      }
    });
    var first = el.querySelector('input[name="nf-scope"]');
    if (first) first.focus();
  };

  /* ------------------------------------------------------------------ */
  /* Warenkorb                                                           */
  /* ------------------------------------------------------------------ */

  P.handleBundleAddToCart = function () { return this.nfAddToCart(); };
  // Alter Weg (interceptAddToCart in nf-bundle-selector.js: Absenden eines /cart/add-Formulars bei gewählten Fronten)
  // lief über addBundleToCart OHNE die NF-Eigenschaften (Gruppe, Bearbeiten, Griffposition) → auf denselben Weg leiten
  P.addBundleToCart = function () { return this.nfAddToCart(); };

  P.nfAddToCart = async function () {
    // Griffe je Stil: nicht passende Griffe nie in den Warenkorb (Hinweis, Liste und Summen neu)
    if (typeof this.enforceStyleRule === 'function' && this.enforceStyleRule().length) this.nfAfterChange();
    if (!this.selectedProducts.size) return;
    if (this._nfAdding) return;
    this._nfAdding = true;
    var self = this;
    var btn = this.scopedQuery('[data-bundle-add-to-cart]');
    try {
      if (btn) btn.setAttribute('aria-busy', 'true');
      var cart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
      // „Bearbeiten“ (nf_replace) mit unvollständig geladenem Link: Zeilen, die nicht geladen wurden, aber
      // noch im Warenkorb liegen, würde das Ersetzen unten entfernen → sperren und Hinweis zeigen.
      var replaceId = new URLSearchParams(location.search).get('nf_replace');
      if (replaceId && this._nfRestoreIncomplete && this._nfRestoreMissing && this._nfRestoreMissing.size) {
        var lost = (cart.items || []).filter(function (i) {
          return i.properties && i.properties._bundle_id === replaceId && self._nfRestoreMissing.has(String(i.variant_id));
        });
        if (lost.length) {
          if (typeof this.showRestoreIncompleteNotice === 'function') this.showRestoreIncompleteNotice(lost.length, true);
          return;
        }
      }
      this.nfGriffRekey();   // Schlüssel = Variante + Griffposition, bevor Bearbeiten-Link und Zeilen entstehen
      var ids = new Set();
      (cart.items || []).forEach(function (i) { if (i.properties && i.properties._bundle_id) ids.add(i.properties._bundle_id); });
      var boxNumber = ids.size + 1;
      var rnd = Math.floor(Math.random() * 90000) + 10000;
      var bundleId = 'bundle_' + Date.now() + '_' + rnd;
      var offer = '#' + rnd;
      var editUrl = null;
      try {
        var u = new URL(this.generateShareableURL());
        u.searchParams.delete('preview_theme_id');
        u.searchParams.delete('nf_replace');
        u.searchParams.set('nf_replace', bundleId);
        editUrl = u.pathname + u.search;
      } catch (e) {}
      this.detectAndSetMainProductColor();
      if (!this.selectedColorFilter) this.selectedColorFilter = this.nfReadStepOneColor();
      var stepBg = this.nfReadStepOneBg();   // Rückfall für Zeilen ohne Hintergrund-Option
      var group = this.nfGroupTitle();
      var styleLine = this.nfStyleLine();
      var config = this.nfCartConfigLine();
      var mainImage = this.nfGroupImage();
      var items = [], idx = 1;
      this.selectedProducts.forEach(function (it, key) {
        if (typeof self.isBlockedByStyleRule === 'function' && self.isBlockedByStyleRule(it.product, it.sectionId)) return;
        var props = {
          '_bundle_id': bundleId,
          '_bundle_component': 'true',
          '_component_index': String(idx++),
          '_box_number': String(boxNumber),
          '_nf_group': group,
          '_nf_config': config,
          '_nf_label': self.nfItemLabel(it),
          // Zusammenstellungs-/Angebotsnummer nur intern (Admin-Bestellung): mit „_“ zeigen Warenkorb, Kasse und
          // Bestellseite sie nicht (Felix 13.10.2026). Gruppiert wird weiter über _bundle_id.
          '_Bundle': 'Bundle ' + offer + ' - Box ' + boxNumber,
          '_Offer ID': offer
        };
        // Stil · Oberfläche ohne Farbe: der Drawer setzt die Farbe aus den Zeilen selbst dazu
        if (styleLine) props['_nf_style'] = styleLine;
        if (editUrl && editUrl.length < 1500) props['_nf_edit'] = editUrl;
        // _nf_img (neu, Farbbild) statt _nf_image (altes Hauptbild in fester Farbe): der Drawer erkennt ältere Zeilen daran
        if (mainImage) props['_nf_img'] = mainImage;
        // Hintergrund aus der gewählten Variante (nicht aus Schritt 1) – Variante und Eigenschaft passen so immer zusammen
        var bi = bgIndex(it.product);
        var bg = (bi !== -1 && vOpt(it.selectedVariant, bi)) || stepBg;
        if (bg) {
          props['_background_color'] = bg;
          props['Hintergrund Farbe'] = bg;
        }
        // Griffposition: für jede berechtigte Front immer (auch beim Standard) – sichtbar + Code für Abgleich/Teilen
        var gs = gSpec(it.product);
        if (gs) {
          var gp = G.props(gs, self.nfGriffOf(it, key));
          props['Griffposition'] = gp['Griffposition'];
          props['_nf_griff'] = gp['_nf_griff'];
        }
        items.push({ id: parseInt(it.selectedVariant.id, 10), quantity: it.quantity || 1, properties: props });
      });
      var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
      if (!res.ok) {
        var err = {};
        try { err = await res.json(); } catch (e) {}
        throw new Error(err.description || err.message || 'Fehler beim Hinzufügen zum Warenkorb');
      }
      // "Bearbeiten" aus dem Warenkorb: alte Zusammenstellung erst NACH erfolgreichem Hinzufügen entfernen
      var params = new URLSearchParams(location.search);
      var replace = params.get('nf_replace');
      if (replace) {
        var fresh = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
        var updates = {};
        (fresh.items || []).forEach(function (i) { if (i.properties && i.properties._bundle_id === replace) updates[i.key] = 0; });
        var removedOk = true;
        if (Object.keys(updates).length) {
          removedOk = false;
          for (var attempt = 0; attempt < 2 && !removedOk; attempt++) {
            try {
              var ru = await fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
              removedOk = ru.ok;
            } catch (e) { removedOk = false; }
          }
        }
        if (removedOk) {
          params.delete('nf_replace');
          params.delete('bundle');
          var qs = params.toString();
          history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
        } else {
          alert('Die neue Zusammenstellung liegt im Warenkorb, die alte konnte aber nicht automatisch entfernt werden. Bitte entferne sie im Warenkorb („Zusammenstellung entfernen“).');
        }
        this._nfReplaced = true;
      }
      this.selectedProducts.clear();
      this.userModifiedVariants && this.userModifiedVariants.clear();
      try { localStorage.removeItem(this.storageKey()); } catch (e) {}
      this.nfAfterChange();
      await this.refreshCartDrawer();
      await new Promise(function (r) { setTimeout(r, 300); });
      var opened = await this.openDrawerCart();
      if (opened) {
        await new Promise(function (r) { setTimeout(r, 200); });
        await this.refreshCartDrawer();
        // Nach dem Ersetzen kann ein früherer Refresh beide Gruppen gezeichnet haben -> hart neu laden
        if (this._nfReplaced && window.ajaxCart && typeof window.ajaxCart.load === 'function') {
          await new Promise(function (r) { setTimeout(r, 400); });
          window.ajaxCart.load(false, true, false, true);
        }
      } else {
        location.href = '/cart';
      }
      this._nfReplaced = false;
    } catch (e) {
      console.error('[NF Bundle UX] Warenkorb:', e);
      alert('Fehler beim Hinzufügen zum Warenkorb: ' + e.message);
    } finally {
      this._nfAdding = false;
      if (btn) btn.removeAttribute('aria-busy');
    }
  };

  /* ------------------------------------------------------------------ */
  /* Start                                                               */
  /* ------------------------------------------------------------------ */

  // "Bearbeiten" aus dem Warenkorb: der Link enthält den Stand beim Hinzufügen.
  // Danach im Warenkorb entfernte oder geänderte Positionen übernehmen.
  P.nfReconcileWithCart = async function (bundleId) {
    try {
      var cart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
      // je Variante + Griffposition (_nf_griff; Zeilen ohne Code = Standard der Front) – sonst bekäme bei zwei
      // Positionen derselben Größe jede Zeile die Summe beider (Mengen verdoppelt)
      var qty = {}, inCart = 0;
      (cart.items || []).forEach(function (i) {
        if (!i.properties || i.properties._bundle_id !== bundleId) return;
        inCart++;
        var k = String(i.variant_id) + '|' + String(i.properties._nf_griff || (G && i.properties['Griffposition'] ? G.fromLabel(i.properties['Griffposition']) : '') || '');
        qty[k] = (qty[k] || 0) + i.quantity;
      });
      // Diese Zusammenstellung liegt nicht in DIESEM Warenkorb – z. B. der „Bearbeiten“-Link eines Kunden, den der
      // Support öffnet, oder ein anderes Gerät: nichts abzugleichen, die Auswahl aus dem Link bleibt (Felix 21.10.:
      // Link mit nf_replace zeigte beim Support keine Fronten, weil jede Position mit Menge 0 herausfiel).
      if (!inCart) return;
      var self = this;
      var merged = new Map();
      this.selectedProducts.forEach(function (it, key) {
        var vid = String(it.selectedVariant.id), g = self.nfGriffOf(it, key), gs = gSpec(it.product);
        var q = qty[vid + '|' + g] || 0;
        if (!gs || g === gs.def) q += (g ? qty[vid + '|'] || 0 : 0);   // alte Zeilen ohne Position = Standard
        if (!q) return;
        var e = { product: it.product, selectedVariant: it.selectedVariant, quantity: q, sectionId: it.sectionId };
        if (g) e.griff = g;
        merged.set(key, e);
      });
      this.selectedProducts = merged;
      this.nfAfterChange();
    } catch (e) { /* Warenkorb nicht lesbar: Stand aus dem Link behalten */ }
  };

  var _origInit = P.init;
  P.init = function () {
    _origInit.call(this);
    var replaceId = new URLSearchParams(location.search).get('nf_replace');
    if (replaceId) {
      var me = this;
      var reconciled = Promise.resolve(this.productsLoadedPromise).then(function () {
        return new Promise(function (r) { setTimeout(r, 100); });
      }).then(function () { return me.nfReconcileWithCart(replaceId); });
      // Fenster warten auch auf den Abgleich mit dem Warenkorb (restorePromise)
      this.restorePromise = Promise.all([this.restorePromise, reconciled]).catch(function () {});
    }
    window.__nfBundle = this; // Debug-Zugriff im Test-Theme
    this.nfWatchColor();
    var self = this;
    // Bereits beim Start die neue Liste zeichnen (auch ohne Auswahl: "+ Türen wählen")
    (this.sections || []).forEach(function (s) { self.renderSelectedProductsForSection(s.sectionId); });
  };

  if (typeof window.initBundleSelectors === 'function' || typeof initBundleSelectors === 'function') {
    (window.initBundleSelectors || initBundleSelectors)();
  }
})();
